export class AreaPathHarnessController {
  public areaPath = "Microsoft\\Windows\\Tablet & Phone";
  public areaPathWithoutInitialPath: string;
  public incorrectInitialAreaPath = "Microsoft\\Windows\\Universal Store\\Membership\\EAE\\Service Desk1\\Core";
  public initialAreaPathUsingNodeData: string;
  public areaPathUsingNodeData: string;
  public initialAreaPathUsingDelayedData = "Microsoft-delayed\\AI-delayed\\Bing-delayed";
  public errorMessage: string;
  public errorMessage1: string;
  public nodeData: any;
  public nodeData1: any;
  public isDisabled = true;
  public dynamicData: any[];
  public data2: any;
  public bigDataSet: any;

  // @ngInject
  constructor($timeout: ng.ITimeoutService) {
    this.dynamicData = this.data;
    this.createBigDataSet();
  }

  public getDelayedData() {
    this.data2 = this.delayedData;
  }

  public onAreaPathChange(isAreaPathInvalid: boolean, areaPath: string) {
    this.errorMessage = isAreaPathInvalid ? "This area path is wrong !" : undefined;
  }

  public onAreaPathChange1(isAreaPathInvalid: boolean) {
    this.errorMessage1 = isAreaPathInvalid ? "This area path is wrong !" : undefined;
  }

  public onAreaPathChange2(isAreaPathInvalid: boolean, areaPath: string, nodeData: any) {
    this.errorMessage1 = isAreaPathInvalid ? "This area path is wrong !" : undefined;
    this.nodeData = isAreaPathInvalid ? undefined : nodeData;
  }

  public onAreaPathChange3(isAreaPathInvalid: boolean, areaPath: string, nodeData: any) {
    this.initialAreaPathUsingNodeData = areaPath;
    this.nodeData1 = isAreaPathInvalid ? undefined : nodeData;
  }

  public onAreaPathChange4(isAreaPathInvalid: boolean, areaPath: string) {
    this.initialAreaPathUsingDelayedData = isAreaPathInvalid ? undefined : areaPath;
  }

  public initialNodePredicate3(nodeData: any): boolean {
    return nodeData.sapId == "335";
  }

  public initialNodePredicate = `public initialNodePredicate3(nodeData: any): boolean {
        return nodeData.sapId == "335";
    }`;

  public onToggleChange(isToggled: boolean) {
    this.dynamicData = isToggled ? this.data1 : this.data;
    this.areaPathWithoutInitialPath = "";
  }

  public createBigDataSet(): any {
    this.bigDataSet = [];
    for (let i = 0; i < 20; i++) {
      let bigData = angular.copy(this.largeData);
      bigData.forEach((data: any) => {
        data.childNodes.forEach((o: any) => {
          o.title = `${o.title} - ${i}`;
        });

        data.title = `${data.title} - ${i}`;
        this.bigDataSet.push(data);
      });
    }
  }

  public data: any[] = [
    {
      title: "Microsoft",
      sapId: 1,
      childNodes: [
        {
          title: "Windows",
          sapId: 2,
          childNodes: [
            {
              title: "Xbox",
              sapId: 3
            },
            {
              title: "Universal Store",
              randomKey: "value",
              sapId: 4,
              childNodes: [
                {
                  title: "Membership",
                  randomKey: "value",
                  sapId: 5,
                  childNodes: [
                    {
                      title: "CMC",
                      randomKey: "value",
                      sapId: 6
                    },
                    {
                      title: "EAE",
                      sapId: 7,
                      childNodes: [
                        {
                          title: "Service Desk",
                          sapId: 8,
                          childNodes: [
                            {
                              title: "Core",
                              randomKey: "value",
                              sapId: 9
                            },
                            {
                              title: "Coral",
                              randomKey: "value",
                              sapId: 10
                            },
                            {
                              title: "Corange",
                              randomKey: "value",
                              sapId: 11
                            },
                            {
                              title: "SDK",
                              randomKey: "value",
                              sapId: 12
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              title: "Tablet & Phone",
              sapId: 13,
              randomKey: "value"
            }
          ]
        },
        {
          title: "Cloud",
          sapId: 14,
          childNodes: [
            {
              title: "Azure",
              sapId: 15,
              childNodes: [
                {
                  title: "Software",
                  randomKey: "value",
                  sapId: 16
                },
                {
                  title: "Network",
                  sapId: 17
                },
                {
                  title: "Identity",
                  randomKey: "value",
                  sapId: 18
                }
              ]
            },
            {
              title: "Infra",
              sapId: 19
            },
            {
              title: "Visual Studio",
              randomKey: "value",
              sapId: 20
            },
            {
              title: "CRM",
              sapId: 21
            }
          ]
        },
        {
          title: "Office",
          sapId: 22,
          childNodes: [
            {
              title: "Skype",
              sapId: 23
            },
            {
              title: "Teams",
              sapId: 24,
              randomKey: "value",
              childNodes: [
                {
                  title: "Android",
                  sapId: 25
                },
                {
                  title: "iOS",
                  sapId: 26
                },
                {
                  title: "Windows",
                  sapId: 27
                },
                {
                  title: "Online",
                  randomKey: "value",
                  sapId: 28
                }
              ]
            },
            {
              title: "Outlook",
              sapId: 29,
              childNodes: [
                {
                  title: "Yammer",
                  randomKey: "value",
                  sapId: 30
                }
              ]
            },
            {
              title: "O365",
              sapId: 31,
              randomKey: "value",
              childNodes: [
                {
                  title: "Powerpoint",
                  sapId: 32
                },
                {
                  title: "Excel",
                  sapId: 33,
                  randomKey: "value"
                },
                {
                  title: "Word",
                  sapId: 34,
                  randomKey: "value",
                  childNodes: [
                    {
                      title: "Android",
                      sapId: 35
                    },
                    {
                      title: "iOS",
                      randomKey: "value",
                      sapId: 36
                    },
                    {
                      title: "Windows",
                      sapId: 37
                    },
                    {
                      title: "Online",
                      randomKey: "value",
                      sapId: 38
                    }
                  ]
                },
                {
                  title: "O365",
                  randomKey: "value",
                  sapId: 39
                }
              ]
            }
          ]
        },
        {
          title: "AI & Research",
          sapId: 40,
          randomKey: "value",
          childNodes: [
            {
              title: "IPG",
              sapId: 41,
              childNodes: [
                {
                  title: "Bing ADs",
                  randomKey: "value",
                  sapId: 42
                },
                {
                  title: "Bing Exp",
                  randomKey: "value",
                  sapId: 43
                }
              ]
            },
            {
              title: "Bing",
              sapId: 44,
              childNodes: [
                {
                  title: "Cortana",
                  randomKey: "value",
                  sapId: 45
                }
              ]
            }
          ]
        }
      ]
    },
    {
      title: "Google",
      sapId: 46,
      randomKey: "value",
      childNodes: [
        {
          title: "Android",
          randomKey: "value",
          sapId: 47
        }
      ]
    }
  ];

  public data1 = [
    {
      title: "Microsoft",
      randomKey: "value",
      sapId: 335,
      childNodes: [
        {
          title: "AI",
          randomKey: "value",
          sapId: 54,
          childNodes: [
            {
              title: "Bing",
              randomKey: "value",
              sapId: 15
            },
            {
              title: "Products",
              randomKey: "value",
              sapId: 51
            }
          ]
        }
      ]
    }
  ];

  public delayedData = [
    {
      title: "Microsoft-delayed",
      randomKey: "value",
      sapId: 335,
      childNodes: [
        {
          title: "AI-delayed",
          randomKey: "value",
          sapId: 54,
          childNodes: [
            {
              title: "Bing-delayed",
              randomKey: "value",
              sapId: 15
            },
            {
              title: "Products-delayed",
              randomKey: "value",
              sapId: 51
            }
          ]
        }
      ]
    }
  ];

  public largeData = [
    {
      title: "Azure",
      childNodes: [
        {
          title: "Antimalware for Azure Cloud Services and Virtual Machines",
          typeId: "1f1a9236-36a5-fe2d-7173-d703c5b4e4d1",
          type: "productname"
        },
        {
          title: "Azure API Management Service",
          typeId: "49161e1d-098a-88a2-5145-8ce4f4407ff4",
          type: "productname"
        },
        {
          title: "Azure ASMS - Backup workflow",
          typeId: "a0421409-4a41-69e1-0f4d-0c2b5b43a879",
          type: "productname"
        },
        {
          title: "Azure Active Directory",
          typeId: "36430322-6075-f09c-b1a4-053008c28769",
          type: "productname"
        },
        {
          title: "Azure Advisor",
          typeId: "cb0f0621-b71c-9f1f-56ee-75dbf1398cdf",
          type: "productname"
        },
        {
          title: "Azure Alert Service",
          typeId: "9d256bfe-d825-c286-0315-d40228e4b4cd",
          type: "productname"
        },
        {
          title: "Azure Analysis Services",
          typeId: "8ec4e743-9d54-f2b6-b803-e9a006d625c2",
          type: "productname"
        },
        {
          title: "Azure App Service",
          typeId: "466ee01b-60c4-b0f7-cd42-b3b51adef889",
          type: "productname"
        },
        {
          title: "Azure Application",
          typeId: "d0f9e8f8-0a7b-84aa-04a3-e5382a5c396a",
          type: "productname"
        },
        {
          title: "Azure AutoScale Service",
          typeId: "ba457fa6-165a-8aa6-b069-d780d02bbf5b",
          type: "productname"
        },
        {
          title: "Azure Automation",
          typeId: "647db79f-ef86-b52d-c9a0-2e878ad417de",
          type: "productname"
        },
        {
          title: "Azure Batch",
          typeId: "e2084d7b-2004-89aa-a847-acf82d428277",
          type: "productname"
        },
        {
          title: "Azure Billing",
          typeId: "668eaa31-abc5-c494-808a-ac82d32a9838",
          type: "productname"
        },
        {
          title: "Azure BizTalk Services",
          typeId: "9c97ba2c-f4c4-ac60-1210-28778b061e8b",
          type: "productname"
        },
        {
          title: "Azure Bot Service",
          typeId: "1cac8721-823b-30f3-2ea3-77ef3366bdf3",
          type: "productname"
        },
        {
          title: "Azure Business Desk Support",
          typeId: "f50e26d4-a349-0e4a-8254-c8782b931ffd",
          type: "productname"
        },
        {
          title: "Azure CDN Akamai",
          typeId: "32d1345c-a5fc-b43c-b9ca-ef1f198cd965",
          type: "productname"
        },
        {
          title: "Azure CDN Verizon",
          typeId: "e6cbaa68-5aa5-1cc5-c52e-8c30081c9e0d",
          type: "productname"
        },
        {
          title: "Azure Cache Services",
          typeId: "9780312a-b5e4-4870-74ce-ca5daff9c689",
          type: "productname"
        },
        {
          title: "Azure Cloud Services",
          typeId: "fe53d88c-2a1b-0d6c-a2e3-4a3e69323c37",
          type: "productname"
        },
        {
          title: "Azure Cognitive Services",
          typeId: "624987f6-0dec-0491-619f-be6aebb7765a",
          type: "productname"
        },
        {
          title: "Azure Container Service",
          typeId: "230470ff-8ffb-dcf0-c72e-92d00ebf7e41",
          type: "productname"
        },
        {
          title: "Azure DNS",
          typeId: "dc6936b6-567c-4ff5-317d-e0d7f93cb03a",
          type: "productname"
        },
        {
          title: "Azure Data",
          typeId: "fa0bf92b-399e-e9b3-9f9a-58395d21b855",
          type: "productname"
        },
        {
          title: "Azure Datamarket",
          typeId: "1d6a3f86-9ad8-15e5-a3f1-0c75d0d0b1ec",
          type: "productname"
        },
        {
          title: "Azure DevTest Labs",
          typeId: "b345347b-1cf4-1559-cb95-5bc2c9d1b622",
          type: "productname"
        },
        {
          title: "Azure DocumentDB",
          typeId: "2628640d-f049-3cc0-367f-f6d7356ac7aa",
          type: "productname"
        },
        {
          title: "Azure EA",
          typeId: "b61d6dba-289a-267d-de43-e10d671a7121",
          type: "productname"
        },
        {
          title: "Azure Event Hubs",
          typeId: "0bea882a-7097-bc4e-7e0a-ff63f60df029",
          type: "productname"
        },
        {
          title: "Azure ExpressRoute",
          typeId: "e92c55f5-0b9c-1c00-8a70-48d9859d6839",
          type: "productname"
        },
        {
          title: "Azure ExpressRoute Carrier Escalation to Engineering",
          typeId: "908d05bf-540c-295a-8f95-b871c1ec5e8f",
          type: "productname"
        },
        {
          title: "Azure Functions",
          typeId: "0da2e33f-eff8-3673-05fa-a1b276179d99",
          type: "productname"
        },
        {
          title: "Azure GCC Business Desk",
          typeId: "14130f1f-5221-2ae9-db7e-cace119265a9",
          type: "productname"
        },
        {
          title: "Azure HDInsight Service",
          typeId: "72e0aea2-e078-eb4e-3c8e-ef31cd5db0bb",
          type: "productname"
        },
        {
          title: "Azure Information Protection",
          typeId: "c966ba14-2da4-da28-4037-200fa4fe18b3",
          type: "productname"
        },
        {
          title: "Azure IoT",
          typeId: "5dd6e828-cbd1-25ae-3245-c1d2cc5f6a25",
          type: "productname"
        },
        {
          title: "Azure Key Vault",
          typeId: "47f1e4dd-1f22-3637-56d6-f82238628f2c",
          type: "productname"
        },
        {
          title: "Azure Load Balancer",
          typeId: "a76823d1-d8b3-b921-989f-3c2c141b3cc1",
          type: "productname"
        },
        {
          title: "Azure Log Integration",
          typeId: "3ac48d64-c7ab-f40a-f368-6b9321940e8c",
          type: "productname"
        },
        {
          title: "Azure Machine Learning",
          typeId: "21cae307-5879-ac5d-41e9-3c8e2063bea8",
          type: "productname"
        },
        {
          title: "Azure Management Portal",
          typeId: "f9d189de-483c-278d-52f2-8e7607e1d5a5",
          type: "productname"
        },
        {
          title: "Azure Media Services",
          typeId: "b3004f9a-9b4e-5eb1-e884-a7a106080a17",
          type: "productname"
        },
        {
          title: "Azure Mobile Engagement",
          typeId: "6ce439ac-cbbd-3501-8d2a-3047041279ed",
          type: "productname"
        },
        {
          title: "Azure Monitor",
          typeId: "5f462b37-b328-25a5-61f6-0da6c42b688e",
          type: "productname"
        },
        {
          title: "Azure Multi-Factor Authentication - PhoneFactor",
          typeId: "b4bfee8e-27bd-96de-917e-ef7faa4463ad",
          type: "productname"
        },
        {
          title: "Azure Network Watcher",
          typeId: "b661ca6e-b50d-d5df-ea60-fc27348bdf80",
          type: "productname"
        },
        {
          title: "Azure Notification Hub",
          typeId: "9a4e3c46-aad1-4db7-e2cf-87412a16d537",
          type: "productname"
        },
        {
          title: "Azure Portal Sign-in or Subscription",
          typeId: "7a51c2c9-390e-959d-6af4-9ae327ac6282",
          type: "productname"
        },
        {
          title: "Azure Quota Changes",
          typeId: "ba93a221-0ed5-cebb-f548-062f00981af4",
          type: "productname"
        },
        {
          title: "Azure Recovery Services",
          typeId: "aba496cb-5652-c6cd-81ac-7c61ad2e25bd",
          type: "productname"
        },
        {
          title: "Azure Relay",
          typeId: "d08ad82f-06f8-0f60-d4b8-684e1e466027",
          type: "productname"
        },
        {
          title: "Azure RemoteApp",
          typeId: "4105dd80-1d11-9511-1fb3-438659a1017c",
          type: "productname"
        },
        {
          title: "Azure SQL",
          typeId: "905ac79c-17a7-8232-b012-75e4f540782c",
          type: "productname"
        },
        {
          title: "Azure Scheduler",
          typeId: "fbdf89d4-e80d-fc44-e28f-dcd32461d092",
          type: "productname"
        },
        {
          title: "Azure Search",
          typeId: "733c91c6-d7f7-4df3-d6b4-ab8764a5aca6",
          type: "productname"
        },
        {
          title: "Azure Security Center",
          typeId: "4b80aad5-f897-85f6-39cf-8f39dda7bda8",
          type: "productname"
        },
        {
          title: "Azure Service",
          typeId: "9dd72c40-a2e8-9271-68af-c567773e3b46",
          type: "productname"
        },
        {
          title: "Azure StorSimple",
          typeId: "d2a6ed57-76c6-294b-2418-e8a06ed91cfc",
          type: "productname"
        },
        {
          title: "Azure Storage",
          typeId: "1600a92c-da08-3e93-512e-a78d122a71db",
          type: "productname"
        },
        {
          title: "Azure Stream Analytics",
          typeId: "d90ce77b-9c27-6cdd-618b-89207ed57d2d",
          type: "productname"
        },
        {
          title: "Azure Subscription Management",
          typeId: "c5ce451c-1253-96ca-ff54-dfe0c962cdf9",
          type: "productname"
        },
        {
          title: "Azure Support for Cloud Deutschland",
          typeId: "18c0eb7b-7915-66a0-dfe9-7e9ef2b0d92e",
          type: "productname"
        },
        {
          title: "Azure Traffic Manager Service",
          typeId: "78a40998-91ef-af35-2dc0-6f9bd348cf55",
          type: "productname"
        },
        {
          title: "Azure VPN Gateway",
          typeId: "4ae8d67c-6793-3566-4ac9-96f7b8948c62",
          type: "productname"
        },
        {
          title: "Azure Virtual",
          typeId: "7ca440f1-88df-eb5c-8b05-d2ae37dcc028",
          type: "productname"
        },
        {
          title: "Azure Virtual Machine running",
          typeId: "4ed46f55-3fb4-7f27-f805-5924ff2aa4c2",
          type: "productname"
        },
        {
          title: "Azure Web App",
          typeId: "fa6ec9c6-8e85-66ce-0e08-b991cbfb6b66",
          type: "productname"
        },
        {
          title: "Azure sign-up process",
          typeId: "72271e5e-f2ac-c685-843f-59f3c09d4fef",
          type: "productname"
        }
      ]
    },
    {
      title: "Band",
      childNodes: [
        {
          title: "Band",
          typeId: "854c9cb6-aaee-ddeb-082c-e3bb7cb2f787",
          type: "productname"
        }
      ]
    },
    {
      title: "Bing",
      childNodes: [
        {
          title: "Bing",
          typeId: "9bbb6e32-f8d4-f3d9-549a-6e1427b11586",
          type: "productname"
        },
        {
          title: "Bing Bar",
          typeId: "b3f22593-60d7-5828-6a94-90c03c50e27a",
          type: "productname"
        },
        {
          title: "Bing Places for Business",
          typeId: "0ff51c1e-995c-acd1-76dc-e4e65404ac1d",
          type: "productname"
        },
        {
          title: "Bing cashback",
          typeId: "0679efa1-70a1-e82d-93ee-645bb2fd0e3b",
          type: "productname"
        },
        {
          title: "Bing local",
          typeId: "2086b2f1-24be-9603-f76e-465edb164b57",
          type: "productname"
        },
        {
          title: "Bing maps",
          typeId: "e248ec41-3106-731b-ac8e-9fb6f45ffcbd",
          type: "productname"
        },
        {
          title: "Bing maps for enterprise",
          typeId: "7e2440cc-b33e-0495-6d6f-f6c5edf43f5e",
          type: "productname"
        }
      ]
    },
    {
      title: "Browser",
      childNodes: [
        {
          title: "Edge",
          typeId: "781494e9-0469-5f4c-e105-ff924be139e2",
          type: "productname"
        },
        {
          title: "Internet Explorer",
          typeId: "b7fb2be1-87da-2a92-94dd-5404283ed2c4",
          type: "productname"
        }
      ]
    },
    {
      title: "Camera",
      childNodes: [
        {
          title: "LifeCam",
          typeId: "cd84e8b9-df3e-913b-a9d2-c70976772660",
          type: "productname"
        },
        {
          title: "LifeCam Studio",
          typeId: "c231e608-468d-5be4-fb78-d5738e07df5b",
          type: "productname"
        },
        {
          title: "LifeChat LX-4000",
          typeId: "19542daa-7f7f-1ee5-78ee-6e0ac8cea070",
          type: "productname"
        }
      ]
    },
    {
      title: "Cloud and Online Services",
      childNodes: [
        {
          title: "21Vianet Azure",
          typeId: "c4d16465-9fd5-0e0a-c74c-3228078357cc",
          type: "productname"
        },
        {
          title: "21Vianet MySQL Database Service on Azure",
          typeId: "d8cfc3de-1e02-11f9-c852-3fa2ea0db688",
          type: "productname"
        },
        {
          title: "Cloud Platform System",
          typeId: "b2e088c0-6dff-87a2-cc86-da7e6a7c262d",
          type: "productname"
        },
        {
          title: "Dynamics 365",
          typeId: "935610df-bf34-7b5b-55d8-7a97640a8b71",
          type: "productname"
        },
        {
          title: "GigJam",
          typeId: "bf732d92-dc81-d5d0-9478-a75193dfb7b2",
          type: "productname"
        },
        {
          title: "MSfC Azure-Azure Apps (IaaS)",
          typeId: "9633fe37-69ff-1fdc-f3e4-dc9b01bac714",
          type: "productname"
        },
        {
          title: "MSfC Azure-Modern Apps",
          typeId: "89822dea-65ff-cb47-b27e-aa9aa41800f8",
          type: "productname"
        },
        {
          title: "MSfC Azure-VM",
          typeId: "65fb08e1-278c-5c55-c6f2-c0d0bc647396",
          type: "productname"
        },
        {
          title: "MSfC CRM Online",
          typeId: "be34f7b2-656c-eab0-1187-eab2a252bb67",
          type: "productname"
        },
        {
          title: "MSfC Custom",
          typeId: "8cd40bd9-156e-c5d3-08c6-7e6c8675678c",
          type: "productname"
        },
        {
          title: "MSfC Exchange",
          typeId: "f1cc96d4-d397-1a3a-c963-8b7995038be5",
          type: "productname"
        },
        {
          title: "MSfC O365-Exchange Online",
          typeId: "3a833a4e-3797-0642-875c-892cfcd5c50f",
          type: "productname"
        },
        {
          title: "MSfC O365-Identity Mgmt Online",
          typeId: "d271b803-509b-33e6-5f96-6596c24c5b20",
          type: "productname"
        },
        {
          title: "MSfC O365-Lync Online",
          typeId: "84ce5124-3ffb-2c9f-2e98-7d37b4f06112",
          type: "productname"
        },
        {
          title: "MSfC O365-SharePoint Online",
          typeId: "e53d465b-07fe-91cc-fa8d-40c26496c7cc",
          type: "productname"
        },
        {
          title: "MSfC OneDrive",
          typeId: "43cd3e50-6bee-7c44-7331-9cd23d9068f8",
          type: "productname"
        },
        {
          title: "MSfC Yammer",
          typeId: "f8421e6a-fe17-f69a-b91c-5cb29daf28ed",
          type: "productname"
        },
        {
          title: "Marketplace Publisher",
          typeId: "d2527d36-40ec-6085-aa70-4b6b16c6ad75",
          type: "productname"
        },
        {
          title: "Micosoft Azure Container Registry",
          typeId: "30c44d76-1976-466f-94b7-0010caa8804f",
          type: "productname"
        },
        {
          title: "Operations Management Suite",
          typeId: "810a1419-8115-a6e7-57d5-1af17d0171f6",
          type: "productname"
        },
        {
          title: "PowerApps",
          typeId: "9af11a86-f30c-b6b8-3138-def5baf29a3a",
          type: "productname"
        },
        {
          title: "R Server",
          typeId: "433eccc2-d1a4-7c6e-98c9-587ac44d97c2",
          type: "productname"
        },
        {
          title: "Revolution Analytics",
          typeId: "c8fbf899-04d3-fab9-3422-641f4f1f351b",
          type: "productname"
        },
        {
          title: "Scout (InMage – 8.0)",
          typeId: "b9b40803-bf5a-dcfa-fc40-0ea31c20d4d1",
          type: "productname"
        },
        {
          title: "StaffHub",
          typeId: "9c68856e-8c70-6240-36ae-d0102fdd26ea",
          type: "productname"
        },
        {
          title: "Virtual Machine - Cloud Foundry",
          typeId: "a199e3d7-958f-d072-0479-b1f3e3992ce9",
          type: "productname"
        }
      ]
    },
    {
      title: "Design Tools, Photos and Publishing",
      childNodes: [
        {
          title: "Expression Blend",
          typeId: "14c992e8-42e4-fafa-26d6-4bf81363026a",
          type: "productname"
        },
        {
          title: "Expression Design",
          typeId: "a4a84d30-5a03-39bb-9c76-6244e83b90ee",
          type: "productname"
        },
        {
          title: "Expression Encoder",
          typeId: "2b1410c3-e73d-258b-58e0-6c40dbbc637f",
          type: "productname"
        },
        {
          title: "Expression Studio",
          typeId: "d5bd89b8-5066-14da-f949-2e876a929641",
          type: "productname"
        },
        {
          title: "Expression Web",
          typeId: "23e40857-812f-43eb-910d-ff84743a99e8",
          type: "productname"
        },
        {
          title: "NOOK for Windows",
          typeId: "0ed64505-c774-64bf-aedd-481841f0c267",
          type: "productname"
        }
      ]
    },
    {
      title: "Developer Tools",
      childNodes: [
        {
          title: ".NET Core 1.0",
          typeId: "38c3c4f5-68b7-87d5-02e7-3f0ec982d48d",
          type: "productname"
        },
        {
          title: ".NET Framework",
          typeId: "f702181a-0be4-76d7-5cfd-cb86c10e3897",
          type: "productname"
        },
        {
          title: ".NET Micro Framework",
          typeId: "cb81f7be-e032-9b7e-3d8b-f9b3fad09a33",
          type: "productname"
        },
        {
          title: "AJAX Library",
          typeId: "0a17f3c2-e83f-15e9-b75b-b21516366214",
          type: "productname"
        },
        {
          title: "AJAX Library 3.5",
          typeId: "6d2510a8-f23c-edb6-2324-e3c1d425b0b9",
          type: "productname"
        },
        {
          title: "ASP .NET",
          typeId: "b87b3810-ad85-87e9-e869-8fbe351e2b13",
          type: "productname"
        },
        {
          title: "ASP .NET 2.0 AJAX Extensions",
          typeId: "e34227fa-efdc-0693-54a5-0f013e6847b8",
          type: "productname"
        },
        {
          title: "ASP .NET Core 1.0",
          typeId: "9ab0a91a-d469-daf0-5f0b-8a38b97d3c48",
          type: "productname"
        },
        {
          title: "ASP .NET MVC 2.0",
          typeId: "22d164b7-dfda-7003-6363-09345e407ca0",
          type: "productname"
        },
        {
          title: "Agents for Visual Studio 2012",
          typeId: "8a4aac65-b107-57bf-e5a2-391fefd0f9aa",
          type: "productname"
        },
        {
          title: "Application Compatibility Toolkit 5.0",
          typeId: "410dfd00-750e-8037-d969-a33d783271bc",
          type: "productname"
        },
        {
          title: 'Desktop Bridge ("Centennial")',
          typeId: "e171be31-6e6f-e489-0f96-e6a573f98021",
          type: "productname"
        },
        {
          title: "Device Emulator 2.0",
          typeId: "214220f3-901f-b8d1-a4aa-5da4ff9d5075",
          type: "productname"
        },
        {
          title: "ESP",
          typeId: "4d8ad453-50f9-80d5-b661-1fe4019f9841",
          type: "productname"
        },
        {
          title: "ESP Software Developer Kit",
          typeId: "0b58fac5-a4e6-ad74-9269-88a9e079648d",
          type: "productname"
        },
        {
          title: "Entity Framework Core 1.0",
          typeId: "f71c3ab5-baa0-16cb-40e2-79c25d0f0076",
          type: "productname"
        },
        {
          title: "Flow",
          typeId: "eee14169-768b-1ce5-764d-35f1a6f32724",
          type: "productname"
        },
        {
          title: "Hardware Lab Kit for Windows 10",
          typeId: "e0027539-9723-6ae3-5a42-df7c4d74b5e0",
          type: "productname"
        },
        {
          title: "Havok",
          typeId: "1fa2b0bd-a4cf-31b2-867b-3a15d75904a7",
          type: "productname"
        },
        {
          title: "HockeyApp",
          typeId: "ed7a68c2-0eba-8689-1075-389ece965268",
          type: "productname"
        },
        {
          title: "IntelliTrace Collector for Visual Studio",
          typeId: "7cbb0ef9-3919-640e-95c4-38bdf0e9c8ba",
          type: "productname"
        },
        {
          title: "Kinect for Windows Software Development",
          typeId: "5829ca38-3bd7-0aa5-78e8-9ae724d2c729",
          type: "productname"
        },
        {
          title: "Lync 2013 Software Development Kit",
          typeId: "1da62950-ac22-13f3-7823-f29fc990790e",
          type: "productname"
        },
        {
          title: "Lync Server 2010 Conference Call Control Software Development Kit",
          typeId: "3a155748-df5b-efbf-8f4d-90d1e51c12c6",
          type: "productname"
        },
        {
          title: "Lync Server 2013 Persistent Chat Software Development Kit",
          typeId: "06372bc3-5f1d-70dc-7675-342fae926ee3",
          type: "productname"
        },
        {
          title: "Lync Server 2013 Software Development Kit",
          typeId: "98c125a1-8a15-069d-06ad-9dffb5a64b8f",
          type: "productname"
        },
        {
          title: "Microsoft Deployment Agent 2013",
          typeId: "36f4415e-77ac-f699-9895-f0e38a51e193",
          type: "productname"
        },
        {
          title: "Office Communications Server 2007 Software Development Kit",
          typeId: "9fcb4ca9-35b5-2f96-5fc0-1d2458db1a1b",
          type: "productname"
        },
        {
          title: "Online Services Interface",
          typeId: "07ddfa57-73ad-0af6-8d9a-715be104016a",
          type: "productname"
        },
        {
          title: "Passport Network 3.0",
          typeId: "9a1a01a4-eb57-ac83-0968-476357a31128",
          type: "productname"
        },
        {
          title: "Platform Ready Test Tool 3.0",
          typeId: "01b78c60-74f4-a187-aacb-84bfd3164862",
          type: "productname"
        },
        {
          title: "PlayReady Server Software Development Kit v. 2.0",
          typeId: "fc44c414-e059-197c-c5db-71ac08ed7983",
          type: "productname"
        },
        {
          title: "ProClarity SharePoint Viewer 6.3",
          typeId: "6f7a7c85-2fbc-71d7-bec3-3e56e095acb9",
          type: "productname"
        },
        {
          title: "ProClarity Software Development Kit 6.3",
          typeId: "71021744-b7f4-7094-0a7f-3e4f0f57aca7",
          type: "productname"
        },
        {
          title: "ProClarity for Reporting Services 6.3",
          typeId: "ddf31bfd-4bc2-50d2-19cb-63ccf1b155d6",
          type: "productname"
        },
        {
          title: "Release Management",
          typeId: "10346022-8112-4143-5558-23c3f1d8e9a2",
          type: "productname"
        },
        {
          title: "Release Management for Visual Studio 2015",
          typeId: "b0149d94-5678-733c-4d81-7ab282815b49",
          type: "productname"
        },
        {
          title: "SharePoint 2010 Administration Toolkit",
          typeId: "b3ece662-b837-fbeb-6bfc-edc5ff36ba5b",
          type: "productname"
        },
        {
          title: "SharePoint Administration Toolkit",
          typeId: "52fcbf13-1214-90ab-5315-56605803bc4a",
          type: "productname"
        },
        {
          title: "Silverlight for Windows",
          typeId: "c64f36da-5536-f009-1487-c89b3cc0fb1d",
          type: "productname"
        },
        {
          title: "Subscription and Commerce Service",
          typeId: "0e3383fa-2c81-5c6e-3dc7-eeb504abb70e",
          type: "productname"
        },
        {
          title: "Sync Framework",
          typeId: "f2011523-605c-ecba-0c57-1bf54dd5f050",
          type: "productname"
        },
        {
          title: "Synchronization Services for ADO.NET 1.0 Service Pack 1",
          typeId: "ff142a7b-d1f8-54a7-2452-3048ca1fa6cc",
          type: "productname"
        },
        {
          title: "System Center Updates Publisher 4.5",
          typeId: "b7a85886-c96b-2504-1876-50d14bd4f336",
          type: "productname"
        },
        {
          title: "TFS Migrator Preview",
          typeId: "77404ed9-4485-96cf-8427-46fe588591cc",
          type: "productname"
        },
        {
          title: "Test Agent",
          typeId: "6ff28f11-df02-d12f-51aa-1ce133202b05",
          type: "productname"
        },
        {
          title: "Test Controller",
          typeId: "656abfe7-26da-6a72-a3c1-19fc93b0307d",
          type: "productname"
        },
        {
          title: "UPnP Certification Test Tool",
          typeId: "2549ba41-223a-b4d5-3f52-1e189543bbe4",
          type: "productname"
        },
        {
          title: "Unified Communications AJAX Software Development Kit",
          typeId: "60e91586-d271-5d4c-6a0f-8d1f15c2b9f7",
          type: "productname"
        },
        {
          title: "Visual J# Version 2.0 Redistributable Package Second Edition",
          typeId: "20116be3-41f1-1a4e-04b5-202ece428d24",
          type: "productname"
        },
        {
          title: "Visual SourceSafe 2005",
          typeId: "3afad09a-49f3-c1d0-e266-d0ece0aa2a8a",
          type: "productname"
        },
        {
          title: "Visual Studio 2008",
          typeId: "d9b98ff4-3066-dda7-90b7-67dd5a895d7b",
          type: "productname"
        },
        {
          title: "Visual Studio 2008 Shell (integrated mode)",
          typeId: "fb5770db-7d3a-dd8b-c0a8-d5e91025cb20",
          type: "productname"
        },
        {
          title: "Visual Studio 2010",
          typeId: "1ff611b8-2a3d-e31e-c709-a6fbf307d38b",
          type: "productname"
        },
        {
          title: "Visual Studio 2010 Remote Debugger",
          typeId: "eaa7dca0-67fc-6151-9c2f-1ecbaccbff00",
          type: "productname"
        },
        {
          title: "Visual Studio 2012",
          typeId: "ca66b979-235a-5e7c-f683-58419e2d6023",
          type: "productname"
        },
        {
          title: "Visual Studio 2013",
          typeId: "d2682c24-57b2-80d3-eba3-4c79ab53b857",
          type: "productname"
        },
        {
          title: "Visual Studio 2015",
          typeId: "eb764efa-4b76-7e13-e69f-07220b6f422c",
          type: "productname"
        },
        {
          title: "Visual Studio 2017",
          typeId: "906e0f93-b948-7a66-5d57-013f51ae9246",
          type: "productname"
        },
        {
          title: "Visual Studio 2017 RC Chat",
          typeId: "7df2f0e7-7be1-c2e2-26d0-5a188e74a2a1",
          type: "productname"
        },
        {
          title: "Visual Studio Code",
          typeId: "6cd6aa9a-42b9-60f1-fd14-23ee783d3aad",
          type: "productname"
        },
        {
          title: "Visual Studio Express 2012",
          typeId: "c8549cf6-55bb-96e1-2fb0-513b312e7a5d",
          type: "productname"
        },
        {
          title: "Visual Studio Lab Management 2010",
          typeId: "da82514f-f97b-8c51-d2d1-a9579ecfcfa7",
          type: "productname"
        },
        {
          title: "Visual Studio LightSwitch 2011",
          typeId: "5f189724-402f-5236-4e32-b9a42f7e8f24",
          type: "productname"
        },
        {
          title: "Visual Studio Professional 2012",
          typeId: "1dc82f36-aadb-0b7b-e177-b61d7bae5393",
          type: "productname"
        },
        {
          title: "Visual Studio Team Agents 2010",
          typeId: "ed0ebb00-0799-4948-e2bb-2c32d16f8e6a",
          type: "productname"
        },
        {
          title: "Visual Studio Test Professional",
          typeId: "55d62939-1eca-c458-d4bc-a9d079629f51",
          type: "productname"
        },
        {
          title: "Visual Web Developer 2010 Express",
          typeId: "622eb75a-ee8e-45d3-21a0-f77b9dca2ac3",
          type: "productname"
        },
        {
          title: "WebMatrix",
          typeId: "a61c02ff-7a05-9326-9d75-db1cd5bb7cb2",
          type: "productname"
        },
        {
          title: "Windows 10 Universal App Dev",
          typeId: "036a40c9-07ab-8708-fff1-125688faedb9",
          type: "productname"
        },
        {
          title: "Windows 8.x Store App Dev",
          typeId: "c1ed19b5-e429-c72f-3f89-6a9403c10d76",
          type: "productname"
        },
        {
          title: "Windows App Certification Kit",
          typeId: "33de244a-9ff4-3b83-4596-9d6586486004",
          type: "productname"
        },
        {
          title: "Windows Communication Foundation",
          typeId: "8b615f4c-5db8-3bf1-2d5c-dbb25b6676f2",
          type: "productname"
        },
        {
          title: "Windows DevCenter app publishing",
          typeId: "af46947a-8756-c4bd-9f52-dab68eb4af86",
          type: "productname"
        },
        {
          title: "Windows Driver Kit",
          typeId: "e41daaa6-4ae4-0b42-abeb-d40af28ec030",
          type: "productname"
        },
        {
          title: "Windows Embedded Device Manager Software Development Kit",
          typeId: "63a710ee-d389-caf0-322f-b3140920a438",
          type: "productname"
        },
        {
          title: "Windows Hardware Certification Kit for Windows 8.1",
          typeId: "f8003004-e1a7-1ad8-c86c-3ce9bdd418ed",
          type: "productname"
        },
        {
          title: "Windows Identity Foundation",
          typeId: "0002ffcc-e96e-84a4-7489-e06e70e9faf3",
          type: "productname"
        },
        {
          title: "Windows Mobile Application Development",
          typeId: "b45a2aa3-df57-a622-ae7e-84d053852ea1",
          type: "productname"
        },
        {
          title: "Windows Phone SDK 8.0",
          typeId: "f1403332-e488-816f-da4a-0e0412587152",
          type: "productname"
        },
        {
          title: "Windows Security Center Software Development Kit",
          typeId: "6e5c9308-5ef0-3be5-ceba-b0b05669bf35",
          type: "productname"
        },
        {
          title: "Windows Software Development Kit",
          typeId: "693d885c-d4b7-af2a-7f3f-4ebccf416386",
          type: "productname"
        },
        {
          title: "Winternals Administrator's Pak 4.2",
          typeId: "f4b10643-2baa-5c85-876c-d15f79c9405c",
          type: "productname"
        },
        {
          title: "Winternals Protection Manager 1.0",
          typeId: "56bcb68b-4ff0-1a56-1662-b274a043ab21",
          type: "productname"
        },
        {
          title: "Winternals Recovery Manager 1.2",
          typeId: "b0ac9a72-a747-e771-000f-fdcb80cd2120",
          type: "productname"
        },
        {
          title: "Workflow Manager Tools for Visual Studio 2012",
          typeId: "27412f61-ab23-c2b1-4955-a75a8d1c1ab7",
          type: "productname"
        },
        {
          title: "Xamarin",
          typeId: "5e3e3af3-a72b-1571-8e58-c27f744e4a5f",
          type: "productname"
        },
        {
          title: "jQuery with ASP .NET MVC 2",
          typeId: "234b4b4c-b346-321d-4b16-3e2d62d8f32b",
          type: "productname"
        }
      ]
    },
    {
      title: "Health Solutions",
      childNodes: [
        {
          title: "HealthVault",
          typeId: "6131dc63-2fb8-7356-9513-45beb820a86c",
          type: "productname"
        },
        {
          title: "HealthVault Connection Center",
          typeId: "ca3a27d7-5798-dc85-b6c3-d222d568c264",
          type: "productname"
        },
        {
          title: "HealthVault for Mobile",
          typeId: "65cf2176-0fc5-d8d2-22ff-a3444a538736",
          type: "productname"
        }
      ]
    },
    {
      title: "HoloLens",
      childNodes: [
        {
          title: "HoloLens",
          typeId: "d008a19e-5e54-d93c-f7cf-6c6a7dc4f5ae",
          type: "productname"
        }
      ]
    },
    {
      title: "Keyboard",
      childNodes: [
        {
          title: "All-in-One Media Keyboard",
          typeId: "4c813fc2-c25c-2086-e0cb-8920aaddd69e",
          type: "productname"
        },
        {
          title: "Arc Keyboard",
          typeId: "5aa5f50e-f79a-b211-0d52-27475cf2c1f8",
          type: "productname"
        },
        {
          title: "Bluetooth Mobile Keyboard 5000",
          typeId: "26c536ae-b51e-7fd9-8104-b87cdb4bd9d2",
          type: "productname"
        },
        {
          title: "Comfort Curve Keyboard 2000",
          typeId: "84302e06-6e88-55be-1b43-83e7f42794f4",
          type: "productname"
        },
        {
          title: "Sculpt Comfort Desktop Keyboard",
          typeId: "d1297c8f-c9ff-c9a8-1159-447d1a497711",
          type: "productname"
        },
        {
          title: "Sculpt Comfort Keyboard",
          typeId: "60c915db-57ca-82d8-c7d8-286dc0afb73c",
          type: "productname"
        },
        {
          title: "Sculpt Ergonomic Desktop Keyboard",
          typeId: "3cffd2f1-d612-abd1-11e1-e1fd2b0cbdbc",
          type: "productname"
        },
        {
          title: "Sculpt Ergonomic Keyboard for Business",
          typeId: "59378e36-353c-4845-fc2e-96fbcb77457e",
          type: "productname"
        },
        {
          title: "Sculpt Mobile Keyboard",
          typeId: "b41c1792-ed50-8a13-2c62-b18a1ce84d7f",
          type: "productname"
        },
        {
          title: "SideWinder X4 Keyboard",
          typeId: "fcf7f77a-7bf5-2a4a-dc7b-7f66add62399",
          type: "productname"
        },
        {
          title: "Universal Foldable Keyboard",
          typeId: "8f903e27-86a3-6b92-f898-ef95ee98d3be",
          type: "productname"
        },
        {
          title: "Universal Mobile Keyboard",
          typeId: "0fe84c81-bebc-213e-3c70-453c6638cd37",
          type: "productname"
        },
        {
          title: "Wedge Mobile Keyboard",
          typeId: "3cb5855b-f642-78a4-3f70-c3a5a4936d9c",
          type: "productname"
        },
        {
          title: "Wired Desktop Keyboard",
          typeId: "264de0a5-9249-6be4-4ad4-a3152357cf76",
          type: "productname"
        },
        {
          title: "Wired Keyboard 600",
          typeId: "ae161978-eb3c-9fe4-31b7-21e2e15116d4",
          type: "productname"
        },
        {
          title: "Wireless Comfort Desktop 5050 Keyboard",
          typeId: "09f27be3-f2b4-cb91-abce-cb667b0fbb07",
          type: "productname"
        },
        {
          title: "Wireless Desktop Keyboard",
          typeId: "92d7c0f9-cb45-0f98-462c-ee45273099e1",
          type: "productname"
        },
        {
          title: "Wireless Keyboard 2000",
          typeId: "98693c1d-4a7f-fa0a-9714-1802ae3b7cec",
          type: "productname"
        },
        {
          title: "Wireless Optical Desktop 1000",
          typeId: "cf656436-bb57-ab62-b0c7-762227b6710c",
          type: "productname"
        }
      ]
    },
    {
      title: "MSN",
      childNodes: [
        {
          title: "MSN",
          typeId: "49468ac7-64e8-49cc-f59a-efd88b9cdf25",
          type: "productname"
        },
        {
          title: "MSN 9.2 Dial-up",
          typeId: "139e50b4-495a-84ff-6e8a-5065206bdf38",
          type: "productname"
        },
        {
          title: "MSN 9.2 Dial-up Accelerator",
          typeId: "18b3b59d-c475-a19c-0088-e20241f26319",
          type: "productname"
        },
        {
          title: "MSN Autos",
          typeId: "9ddd6999-55da-64b3-0903-562145aa1765",
          type: "productname"
        },
        {
          title: "MSN Connection Center 1.0",
          typeId: "3944b86a-762f-907b-943d-9b99ecbc4fa5",
          type: "productname"
        },
        {
          title: "MSN Direct",
          typeId: "c4d3797e-719b-09bc-8fe3-bff33182c3d1",
          type: "productname"
        },
        {
          title: "MSN Explorer (Premium/Dial-up)",
          typeId: "ddb1ba52-83ad-be72-87fd-893e12233ea8",
          type: "productname"
        },
        {
          title: "MSN Games",
          typeId: "e468cc96-9135-cf78-864c-c36cffe33246",
          type: "productname"
        },
        {
          title: "MSN Mobile 4.0",
          typeId: "e4f62e04-fd60-d2bb-6604-8ee5821b69ea",
          type: "productname"
        },
        {
          title: "MSN Money",
          typeId: "cb883545-47fb-e0dd-7f10-a20e6dd491b3",
          type: "productname"
        },
        {
          title: "MSN Music",
          typeId: "dfce1862-863a-8ff8-f00b-3e677ee5a0bb",
          type: "productname"
        },
        {
          title: "MSN Parental Controls",
          typeId: "016fed1c-306f-06b0-35f0-fda35e1d71ec",
          type: "productname"
        },
        {
          title: "MSN Partner Video Download",
          typeId: "db50320d-08d4-69c2-4f3b-389208480bc2",
          type: "productname"
        },
        {
          title: "MSN Premier Pass Games",
          typeId: "d67add7a-45d5-553e-e57d-7b6926a4519d",
          type: "productname"
        },
        {
          title: "MSN Profiles",
          typeId: "31d8cf5d-0ef1-7f61-d921-d13c385f56ef",
          type: "productname"
        },
        {
          title: "MSN Search",
          typeId: "7d30a084-2229-a9e7-589b-e34c2a5cb0dd",
          type: "productname"
        },
        {
          title: "MSN Shopping",
          typeId: "cbe269b1-7178-a6be-f3dc-97a7e433d9a1",
          type: "productname"
        },
        {
          title: "MSN SideGuide",
          typeId: "9d57b3ce-0880-868b-fea2-38883d679af1",
          type: "productname"
        },
        {
          title: "MSN Toolbar",
          typeId: "70383ceb-5d9f-80ea-1343-511bb3259b59",
          type: "productname"
        },
        {
          title: "MSN Video Downloads",
          typeId: "ef25b24d-6df3-17a9-2309-ac7442457fd7",
          type: "productname"
        },
        {
          title: "MSNBC",
          typeId: "a358348f-b382-9822-24d9-ce7059a5d1bf",
          type: "productname"
        }
      ]
    },
    {
      title: "Mouse",
      childNodes: [
        {
          title: "Arc Touch",
          typeId: "5a0b158a-04fc-e84f-03f4-1ec76080c127",
          type: "productname"
        },
        {
          title: "Comfort Mouse 4500",
          typeId: "443bbaf1-66c5-7ada-3909-87d8c1ab3631",
          type: "productname"
        },
        {
          title: "Comfort Optical Mouse 1000",
          typeId: "ee6e1dac-193f-95db-fd1a-7202f538bfe5",
          type: "productname"
        },
        {
          title: "Designer Bluetooth Desktop Mouse",
          typeId: "540ffd5e-a2b6-0f07-ba3f-218ed033a1bc",
          type: "productname"
        },
        {
          title: "Designer Bluetooth Mouse",
          typeId: "b7815553-38eb-1aa2-61da-890ff798d012",
          type: "productname"
        },
        {
          title: "Explorer Touch Mouse",
          typeId: "d9b410b4-4430-2ad3-eff1-42d6858dabc6",
          type: "productname"
        },
        {
          title: "Habu Laser Gaming Mouse",
          typeId: "6605c3a9-450a-508c-5988-d108773266bd",
          type: "productname"
        },
        {
          title: "IntelliMouse Explorer 3.0 Mouse",
          typeId: "f8c94f28-1da3-f578-17ad-0898f5253ed7",
          type: "productname"
        },
        {
          title: "Ready Mouse",
          typeId: "ba02a079-e7c1-673b-87c7-e18e1dcec332",
          type: "productname"
        },
        {
          title: "Sculpt Comfort Mouse",
          typeId: "ede397a7-01d9-f925-af47-aac7aa8b055e",
          type: "productname"
        },
        {
          title: "Sculpt Ergonomic Mouse",
          typeId: "81319a2e-b5bd-acc0-8dd7-044396bd5cae",
          type: "productname"
        },
        {
          title: "Sculpt Mobile Mouse",
          typeId: "b9a16e55-b8c0-6429-37d2-7eb48e4e2702",
          type: "productname"
        },
        {
          title: "Sculpt Touch Mouse",
          typeId: "e2e11a9d-0a07-e86e-8970-1f9babee7c1b",
          type: "productname"
        },
        {
          title: "SideWinder X8 Mouse",
          typeId: "8bc4590c-f0c3-4de2-7d51-f2db3c5c8160",
          type: "productname"
        },
        {
          title: "Sidewinder X3 Mouse",
          typeId: "23a0c6fb-8e0a-2d21-7603-bb70a13cafad",
          type: "productname"
        },
        {
          title: "Touch Mouse",
          typeId: "f3a0ec95-4212-5a9d-1039-dad389f49d2f",
          type: "productname"
        },
        {
          title: "Wedge Touch Mouse",
          typeId: "4a9cb611-fdd5-8008-584c-8f3abed9cad9",
          type: "productname"
        },
        {
          title: "Wireless Laser Mouse 5000",
          typeId: "73c2599c-6193-83c0-0eb1-a8878408798f",
          type: "productname"
        },
        {
          title: "Wireless Mobile Mouse 1000",
          typeId: "a3dbb8bf-9581-19c5-aafc-2a93b3f2a453",
          type: "productname"
        },
        {
          title: "Wireless Mouse 1000",
          typeId: "cabbf30a-99da-d12b-5532-6618366f7072",
          type: "productname"
        }
      ]
    },
    {
      title: "None",
      childNodes: [
        {
          title: "None",
          typeId: "d204bc90-3580-f56e-4a42-bb9398447a91",
          type: "productname"
        }
      ]
    },
    {
      title: "Office Products",
      childNodes: [
        {
          title: "21Vianet Exchange Online",
          typeId: "38ecf104-44a4-52c9-a189-09a353003178",
          type: "productname"
        },
        {
          title: "21Vianet Lync Online",
          typeId: "aa9d68e1-c3aa-cbd4-5d86-41d2b9e37e71",
          type: "productname"
        },
        {
          title: "21Vianet Office 365",
          typeId: "301ff2c0-d6d8-87fb-13a1-91bc354fee0b",
          type: "productname"
        },
        {
          title: "21Vianet Power BI",
          typeId: "abc3bdb4-384b-cc05-daca-0e25fd6c4ac6",
          type: "productname"
        },
        {
          title: "21Vianet Project",
          typeId: "d43474fd-c7b9-173d-934f-b53cf08f468a",
          type: "productname"
        },
        {
          title: "21Vianet SharePoint Online",
          typeId: "590eaee5-3778-90ab-c0df-a9955213b9b0",
          type: "productname"
        },
        {
          title: "Access",
          typeId: "c56c76df-c31f-8067-4f80-b9fcc7fe536f",
          type: "productname"
        },
        {
          title: "Classroom",
          typeId: "7ca67a7f-5206-f791-001e-ade05bf4c084",
          type: "productname"
        },
        {
          title: "Equipt",
          typeId: "77c89849-3b41-4f35-0105-4808302121be",
          type: "productname"
        },
        {
          title: "Excel",
          typeId: "b1d9df44-1350-9744-ec18-17738c742da2",
          type: "productname"
        },
        {
          title: "Gallatin Technical",
          typeId: "6e67075e-3781-b688-ac90-2c7bb1891468",
          type: "productname"
        },
        {
          title: "InfoPath",
          typeId: "6a51f0de-15c8-eb65-399d-a9aa30225f38",
          type: "productname"
        },
        {
          title: "Interactive Media Manager 2.0",
          typeId: "aa587c5e-c0b3-6467-c27c-6317f99faaeb",
          type: "productname"
        },
        {
          title: "Lync",
          typeId: "d5414359-07ac-2f82-5fd2-5ab417969721",
          type: "productname"
        },
        {
          title: "Lync VDI 2013 plug-in",
          typeId: "102804dc-7384-6e91-cdae-63666ef1426b",
          type: "productname"
        },
        {
          title: "Mediaroom Component Technologies",
          typeId: "8ec0fc0d-fd06-0f13-7191-98d304ef6f62",
          type: "productname"
        },
        {
          title: "Office 2007",
          typeId: "73ad85b4-c195-ac4a-66b2-cec7d2832ecd",
          type: "productname"
        },
        {
          title: "Office 2010",
          typeId: "7044e1b4-21ea-237d-c33e-982ef28299f7",
          type: "productname"
        },
        {
          title: "Office 2013",
          typeId: "5f1a584d-8458-a4df-7d9b-881ccd6f3f68",
          type: "productname"
        },
        {
          title: "Office 2016",
          typeId: "a451d4d9-f92b-1b5d-a159-9a96ab98c891",
          type: "productname"
        },
        {
          title: "Office 365",
          typeId: "e0e7e346-869c-293b-f4f2-252189eb372c",
          type: "productname"
        },
        {
          title: "Office 365 Sway",
          typeId: "020b7951-bd04-f25e-a80e-8caced89a229",
          type: "productname"
        },
        {
          title: "Office Accounting",
          typeId: "32a8a9a7-461f-e8e7-ebe0-7170f78b908c",
          type: "productname"
        },
        {
          title: "Office App Store",
          typeId: "f736e280-2efb-e3a2-309e-74e1ba79f211",
          type: "productname"
        },
        {
          title: "Office Communicator",
          typeId: "c537c85e-6790-4620-dff1-5cdb934a68a6",
          type: "productname"
        },
        {
          title: "Office Diagnostics",
          typeId: "7f81ea07-ca8a-7088-3f7f-e110aa4436d5",
          type: "productname"
        },
        {
          title: "Office Enterprise 2007 Home Use Program",
          typeId: "8d027ad3-ee73-287a-7e40-7187e02767d2",
          type: "productname"
        },
        {
          title: "Office Groove 2007",
          typeId: "fa77a186-d315-73b2-30b8-00a8327f48d9",
          type: "productname"
        },
        {
          title: "Office Groove Enterprise Services",
          typeId: "302019c7-8884-52e9-d95e-3747a6b1fe39",
          type: "productname"
        },
        {
          title: "Office Home and Student 2013 RT",
          typeId: "d3093521-1ca6-cda5-9cba-170d21285f8a",
          type: "productname"
        },
        {
          title: "Office Lens",
          typeId: "262dc5fd-2230-53ed-526e-c3fbd5928767",
          type: "productname"
        },
        {
          title: "Office Live Groove",
          typeId: "c4a266b2-dd26-aab8-b64e-7751a2457e1e",
          type: "productname"
        },
        {
          title: "Office Live Meeting 2007",
          typeId: "b8310e88-19eb-3bf3-3f4f-04ad9d78a90d",
          type: "productname"
        },
        {
          title: "Office Mobile",
          typeId: "dd24c757-cbd2-7ad5-081a-1481b4466ef0",
          type: "productname"
        },
        {
          title: "Office OneNote 2007",
          typeId: "88cfa2d2-141c-a80d-527e-e0615923a2a2",
          type: "productname"
        },
        {
          title: "Office PerformancePoint 2007 Management Reporter",
          typeId: "690be2d0-4d66-b30b-b2e1-fae2859671ef",
          type: "productname"
        },
        {
          title: "Office ProPlus 2013 HUP",
          typeId: "c07acbab-1c41-107f-139c-ae5f6fb2ab60",
          type: "productname"
        },
        {
          title: "Office Professional Plus 2010 Home Use Program",
          typeId: "27a185c1-00c2-6bed-be11-506cdbb47185",
          type: "productname"
        },
        {
          title: "Office SharePoint Server 2007",
          typeId: "87b68001-f123-b03e-dce9-b266a098571f",
          type: "productname"
        },
        {
          title: "Office Store App Development",
          typeId: "b512e46e-4d7c-44e3-988e-a76d3f84fce1",
          type: "productname"
        },
        {
          title: "Office Sway",
          typeId: "35515deb-8e69-307f-a044-79d255e5bc38",
          type: "productname"
        },
        {
          title: "Office Update Site",
          typeId: "abc31bcf-067d-ae0f-e90c-23109f70813e",
          type: "productname"
        },
        {
          title: "Office XP",
          typeId: "6885eac5-11c5-e842-d1e2-fc2b1d074661",
          type: "productname"
        },
        {
          title: "Office for Mac 2011",
          typeId: "01632e9c-16bd-e7a8-a654-d365911b1d8b",
          type: "productname"
        },
        {
          title: "Office for Mac Home and Business 2011 Home Use Program",
          typeId: "1587e254-c83c-ec4b-39e6-546c9cc89222",
          type: "productname"
        },
        {
          title: "Office for iPad",
          typeId: "113ec6ab-6b0e-d101-41ab-d5285f30637f",
          type: "productname"
        },
        {
          title: "OneNote",
          typeId: "ec678dd2-4f98-dcd4-92cf-c4bac419b037",
          type: "productname"
        },
        {
          title: "Outlook",
          typeId: "8fe655fb-c087-ba9f-f737-78f82a1e246f",
          type: "productname"
        },
        {
          title: "Power Map for Excel",
          typeId: "bc75c151-0be6-7a24-acc6-8bccb7c26982",
          type: "productname"
        },
        {
          title: "PowerPoint",
          typeId: "ad0b0185-34eb-9069-e082-b46227bf1238",
          type: "productname"
        },
        {
          title: "Project",
          typeId: "7eee19d5-277f-f689-67d0-a8167e3f477d",
          type: "productname"
        },
        {
          title: "Publisher",
          typeId: "c2a01e56-6296-05ad-188c-b33119c3877c",
          type: "productname"
        },
        {
          title: "SharePoint 2010 For Internet Sites Enterprise",
          typeId: "f38f56a6-384c-1bf6-ba03-9dad43b9a3f9",
          type: "productname"
        },
        {
          title: "SharePoint Designer",
          typeId: "a711ef14-b99b-7bba-7762-4d52c2ae7295",
          type: "productname"
        },
        {
          title: "SharePoint Newsfeed",
          typeId: "04d15dbc-b9e0-43af-a96e-c973c257d29b",
          type: "productname"
        },
        {
          title: "SharePoint Online",
          typeId: "7a4896c7-679a-82b4-f3d7-7da67df3118a",
          type: "productname"
        },
        {
          title: "SharePoint Workspace 2010",
          typeId: "df5c153d-9f2a-f250-76ef-5b908513b01b",
          type: "productname"
        },
        {
          title: "Skype Meeting Broadcast",
          typeId: "614be62f-34c0-461a-c682-3b5cd2a473e1",
          type: "productname"
        },
        {
          title: "Skype Room Systems v2",
          typeId: "f19ee9c0-791d-6285-845b-6bd4aa75ffb9",
          type: "productname"
        },
        {
          title: "Skype for Business",
          typeId: "9e107e78-f23b-73ad-1d29-a0aede291fe2",
          type: "productname"
        },
        {
          title: "Teams",
          typeId: "52a3ee3e-8638-78a3-55b6-f138e722a992",
          type: "productname"
        },
        {
          title: "Visio",
          typeId: "4be336c1-24ed-f399-0e82-10fffa83b53c",
          type: "productname"
        },
        {
          title: "Visio Services in SharePoint Server 2010",
          typeId: "5d2c105b-b7fa-f097-8c80-73d54da6dbf4",
          type: "productname"
        },
        {
          title: "Word",
          typeId: "18f67c92-889b-c8e4-07c3-b4697263927b",
          type: "productname"
        },
        {
          title: "Word Viewer",
          typeId: "65b4e7ff-8cc8-321e-3db5-ddb306dc04d4",
          type: "productname"
        },
        {
          title: "Yammer",
          typeId: "0e2b2e48-8afb-6629-e627-7909e0414c2f",
          type: "productname"
        }
      ]
    },
    {
      title: "Online Services",
      childNodes: [
        {
          title: "Ad-Free Outlook.com Subscription",
          typeId: "fa8072b7-95aa-9667-843b-1591e2a8602c",
          type: "productname"
        },
        {
          title: "Live Connect",
          typeId: "8dbf7c1d-023b-7b2f-2b8f-4ee134493e48",
          type: "productname"
        },
        {
          title: "Live Search Books",
          typeId: "bfdd2418-77ee-5644-3887-9c2703202a41",
          type: "productname"
        },
        {
          title: "Live.com",
          typeId: "063cad81-cf73-1865-eee6-80c932f31022",
          type: "productname"
        },
        {
          title: "OneDrive",
          typeId: "2318ab4a-a126-11ba-5df7-83864e72dce0",
          type: "productname"
        },
        {
          title: "OneDrive Billing and Accounts",
          typeId: "efe0b23c-1b20-4e77-edb7-a0d3e43a592f",
          type: "productname"
        },
        {
          title: "OneDrive for Business",
          typeId: "0325263c-ce2e-ad8c-fd4c-c3377d3b1132",
          type: "productname"
        },
        {
          title: "Outlook.com",
          typeId: "2594d7ad-262e-eb3c-a292-0443331c501f",
          type: "productname"
        },
        {
          title: "Outlook.com Active Views",
          typeId: "a4093191-47d3-dc2a-3312-c5de553fa686",
          type: "productname"
        },
        {
          title: "Partner Online services",
          typeId: "6729d679-2310-9f8f-bb5e-10ac82ce5c0b",
          type: "productname"
        },
        {
          title: "Windows Essentials BYOA",
          typeId: "a67d53a7-21a5-7582-6901-5d4d14bc5af3",
          type: "productname"
        },
        {
          title: "Windows Live",
          typeId: "e70dcdb4-dad5-b45e-2c8c-1a3fcff3ea0c",
          type: "productname"
        },
        {
          title: "Windows Live Gadgets",
          typeId: "cd5de9b4-c346-9a3a-70d9-46fe215c85af",
          type: "productname"
        },
        {
          title: "Windows Live Messenger",
          typeId: "1c82461c-9f00-123d-f1d7-64a3b58803e4",
          type: "productname"
        },
        {
          title: "Windows Live@NET",
          typeId: "f4d43a47-f11e-556b-1ef3-9192ef8975cb",
          type: "productname"
        },
        {
          title: "Windows Marketplace",
          typeId: "c8e04654-1e80-b7c5-41d7-4009ffcde5c8",
          type: "productname"
        },
        {
          title: "account",
          typeId: "eb5dc9f5-84b8-f291-c24e-f5fac31ea716",
          type: "productname"
        },
        {
          title: "powerapps.com Preview",
          typeId: "9a166c76-da6c-4b21-1fcd-997dcce83457",
          type: "productname"
        }
      ]
    },
    {
      title: "Other Hardware",
      childNodes: [
        {
          title: "Enterprise Mobility Suite (EMS)",
          typeId: "b473ffbd-c08c-66a2-7011-99490a8a1d70",
          type: "productname"
        },
        {
          title: "HP Business Decision Appliance",
          typeId: "d4cffa97-3d0a-b54e-907b-b191dce92809",
          type: "productname"
        },
        {
          title: "KIN",
          typeId: "66658a32-2ffb-4992-af87-36f659879512",
          type: "productname"
        },
        {
          title: "Perceptive Pixel by Touch Devices",
          typeId: "751f62ee-1a2a-7fed-3b83-7b6b883ea793",
          type: "productname"
        },
        {
          title: "PixelSense 2.0 Runtime",
          typeId: "cf60e6ec-6382-2d6b-25b4-9e39ba679a1d",
          type: "productname"
        },
        {
          title: "PixelSense 2.0 SDK",
          typeId: "47ce48ed-98db-413d-23f4-44fcb3cb0489",
          type: "productname"
        },
        {
          title: "Presenter 3000",
          typeId: "0e7f6dea-ea05-7d57-481a-7fcce8b6660c",
          type: "productname"
        },
        {
          title: "Wireless Display Adapter",
          typeId: "7aaf492d-8b19-1ec5-2c1f-40bdfeeb1aeb",
          type: "productname"
        }
      ]
    },
    {
      title: "Programs and Services",
      childNodes: [
        {
          title: "ADR Partner Support",
          typeId: "6f0adfa2-1efb-c195-6710-3fbd09b902fb",
          type: "productname"
        },
        {
          title: "CBO Web",
          typeId: "ca71add0-4315-a76d-5775-615907e2a02c",
          type: "productname"
        },
        {
          title: "COOP and Rebates",
          typeId: "a9198873-5963-a84b-ac56-91f67f863c3c",
          type: "productname"
        },
        {
          title: "Channel Developer",
          typeId: "cb2cc1a1-703b-16e8-590e-6e8def9ef37f",
          type: "productname"
        },
        {
          title: "Channel Incentives Platform",
          typeId: "330a2c06-63d3-7fd1-a09f-070a80bccbd5",
          type: "productname"
        },
        {
          title: "China OE Office 365",
          typeId: "2c3b4ba4-fa00-2744-238c-18387657c911",
          type: "productname"
        },
        {
          title: "China OSPA",
          typeId: "6123a47d-b324-e8bb-61e5-0ce2554a277b",
          type: "productname"
        },
        {
          title: "China OSSA Azure",
          typeId: "d834ff5e-8e8e-4a77-27e0-146ff1366be9",
          type: "productname"
        },
        {
          title: "Commerce Platform Commercial",
          typeId: "1bd3ce76-c143-19df-0ca8-6f492b334906",
          type: "productname"
        },
        {
          title: "Corporate and Major Accounts",
          typeId: "7b913aed-5f2f-b4c9-5c5c-81632afa9e80",
          type: "productname"
        },
        {
          title: "ESD Partner Support",
          typeId: "6a9a1f0a-8c0e-d897-0660-e98a73c8f5f7",
          type: "productname"
        },
        {
          title: "M&A Test Offering",
          typeId: "01c36199-9dc6-dbe2-feae-015283be9adb",
          type: "productname"
        },
        {
          title: "Managed Reseller",
          typeId: "a7d183dc-6c19-b62b-09cf-392e1a8fe870",
          type: "productname"
        },
        {
          title: "My Phone",
          typeId: "0aa50bf2-94fc-f9e2-e8d4-95fcc304b67c",
          type: "productname"
        },
        {
          title: "Online Service Advisor",
          typeId: "941bb103-1c5b-349f-ae29-8d0108ccaebf",
          type: "productname"
        },
        {
          title: "PCSafety",
          typeId: "0a76bd10-72d6-83cb-ff1d-2836c64da72e",
          type: "productname"
        },
        {
          title: "Partner Center",
          typeId: "d7c82f5f-254c-7d2c-45fd-2da75b98ae48",
          type: "productname"
        },
        {
          title: "Partner Incentives Reporting",
          typeId: "657531ef-691b-a9ef-6a0c-8aa261a06c93",
          type: "productname"
        },
        {
          title: "Partner Sales Exchange",
          typeId: "c09146f5-111e-f9c5-93e9-a31e4329acd8",
          type: "productname"
        },
        {
          title: "Raspberry Jam",
          typeId: "4bd1e98d-1145-464f-6241-50678d017236",
          type: "productname"
        },
        {
          title: "Romulan Ale",
          typeId: "9a2e0ccf-2d9a-2720-f1af-0a5e010bb53b",
          type: "productname"
        },
        {
          title: "Services Premier Maintained Applications",
          typeId: "21e5e65a-20ca-7e9e-5994-001e4787f3f5",
          type: "productname"
        },
        {
          title: "Software Asset Management",
          typeId: "5b639088-16d4-c77d-0d70-d653a7ec4eb1",
          type: "productname"
        },
        {
          title: "Solution Incentives",
          typeId: "89d1d8ad-0f96-c974-50ea-3977b817814d",
          type: "productname"
        },
        {
          title: "Springfield",
          typeId: "a8309980-e51a-ee1f-afa3-f11e6e0653fc",
          type: "productname"
        },
        {
          title: "Surface Incentives",
          typeId: "b0fcae5b-e1f7-16b3-c9de-dacbae9fca9a",
          type: "productname"
        },
        {
          title: "Surfs Up",
          typeId: "70dc1ffe-b91d-8af1-2d6e-4a7eb9c34acd",
          type: "productname"
        },
        {
          title: "Value-Added Reseller",
          typeId: "08f29c7f-a73b-e78f-17f1-29521f113314",
          type: "productname"
        },
        {
          title: "Virus",
          typeId: "b8fe5eaf-140a-7001-9f15-e29e14c393f9",
          type: "productname"
        },
        {
          title: "Windows 7 Application Compatibility Remediation Program",
          typeId: "3c877a8b-51cd-204d-70e3-d68997eada06",
          type: "productname"
        },
        {
          title: "Windows Phone Store",
          typeId: "0e284f99-314b-3139-0a98-f9b9b95a06c5",
          type: "productname"
        },
        {
          title: "Windows Store",
          typeId: "c991f3b9-5b97-7c07-029e-3f0961d99529",
          type: "productname"
        }
      ]
    },
    {
      title: "Security",
      childNodes: [
        {
          title: "Advanced Threat Analytics",
          typeId: "23354b16-4518-7f6e-0418-52ed8bc3506a",
          type: "productname"
        },
        {
          title: "Cloud App Security",
          typeId: "3e730652-ec9a-d399-e983-850de5e75015",
          type: "productname"
        },
        {
          title: "Enhanced Mitigation Experience Toolkit",
          typeId: "c9eab1c8-0fd6-6f3f-b9e8-6cc5ed42d5fe",
          type: "productname"
        },
        {
          title: "Forefront Endpoint Protection 2010",
          typeId: "60166350-17c9-ddd1-5f34-7498c1d8fb8f",
          type: "productname"
        },
        {
          title: "Forefront Online Protection for Exchange Embedded Filtering",
          typeId: "9892f058-ed02-746c-ccf4-0230e5a38909",
          type: "productname"
        },
        {
          title: "Forefront Protection Suite",
          typeId: "3d21d2e1-4ca6-44f6-63c0-82436cf4b83b",
          type: "productname"
        },
        {
          title: "Forefront Threat Management Gateway 2010",
          typeId: "ccfd8b54-8056-e5a2-bfb7-fa8db21658b1",
          type: "productname"
        },
        {
          title: "Forefront Unified Access Gateway 2010",
          typeId: "affa8c92-bf04-5a13-f28b-186baabc4b93",
          type: "productname"
        },
        {
          title: "Identity Manager 2016",
          typeId: "e4e2bebc-1e20-fda1-2ae9-153b202c4814",
          type: "productname"
        },
        {
          title: "Intelligent Application Gateway 2007",
          typeId: "26dcc0c2-16f9-4128-aa83-b0eda9239807",
          type: "productname"
        },
        {
          title: "Secure Islands",
          typeId: "b8c26d6c-46b4-cc0a-88b8-3b7443e7dee7",
          type: "productname"
        },
        {
          title: "Security Essentials OEM Pre-Installation Kit",
          typeId: "fad4cad5-b674-daa4-9292-8750e9bdd37b",
          type: "productname"
        },
        {
          title: "System Center 2012 Endpoint Protection",
          typeId: "056da9f0-c46e-8deb-ff97-2190fed5bde5",
          type: "productname"
        },
        {
          title: "Windows Defender",
          typeId: "c9bbcd52-44aa-080c-54eb-5da6baf91f2e",
          type: "productname"
        }
      ]
    },
    {
      title: "Server Management Tools",
      childNodes: [
        {
          title: "AVIcode, Inc.",
          typeId: "730b732b-4dfd-f9b1-7ca8-4b8fe6554735",
          type: "productname"
        },
        {
          title: "Active Directory Rights Management Services Client 2.0",
          typeId: "cfaa265b-05de-2b95-16fa-198da5c85815",
          type: "productname"
        },
        {
          title: "Audit and Control Management Server 2013",
          typeId: "8bd1d487-5af9-ab9b-6d74-adfa3809a5e1",
          type: "productname"
        },
        {
          title: "BHOLD Suite",
          typeId: "f3895168-c4f8-75ce-f346-09d203df7b50",
          type: "productname"
        },
        {
          title: "BizTalk Adapters for Host Systems 2.0",
          typeId: "f8685e30-9583-efe3-9687-bf636c70b1e4",
          type: "productname"
        },
        {
          title: "BizTalk WCF Adapter for SQL Server",
          typeId: "de0c0fa0-979c-f034-bea0-5bcdff765dcd",
          type: "productname"
        },
        {
          title: "BlueStripe",
          typeId: "1c591b9c-bbf3-4043-15c0-a3f4274beca1",
          type: "productname"
        },
        {
          title: "Deployment Toolkit",
          typeId: "c199d6eb-9952-c3e4-ca6d-848a505a87b8",
          type: "productname"
        },
        {
          title: "Engyro Product Connectors for System Center Operations Manager 2007",
          typeId: "7b4dc43c-a502-de34-2168-2d75479e4da9",
          type: "productname"
        },
        {
          title: "HPC Pack 2008",
          typeId: "fee8095e-cafe-bbdd-06ff-4fd6149bbe99",
          type: "productname"
        },
        {
          title: "HPC Pack 2008 R2",
          typeId: "6800bd59-8723-d7cc-0020-6a76bc414b2a",
          type: "productname"
        },
        {
          title: "HPC Pack 2012",
          typeId: "228efdbd-051d-7585-4369-e20316f26599",
          type: "productname"
        },
        {
          title: "HPC Pack 2012 R2",
          typeId: "2758235f-10d8-27d5-4397-2b8b0cee739c",
          type: "productname"
        },
        {
          title: "Internet Storage Name Service (iSNS) Server 3.0",
          typeId: "14cfe2a7-b924-2248-ad1b-9e01bc5e3fbf",
          type: "productname"
        },
        {
          title: "Lync Server 2010 Capacity Planning Tool",
          typeId: "c8d0b4dd-37bf-b930-9ec9-a2666854ad90",
          type: "productname"
        },
        {
          title: "Lync Server 2010 Group Chat Software Development Kit",
          typeId: "f33165ba-a600-e478-9d0f-5ec28e8db63c",
          type: "productname"
        },
        {
          title: "Lync Server 2010, Group Chat",
          typeId: "57c2d65f-0fdf-c93d-860b-96580ee8a6d0",
          type: "productname"
        },
        {
          title: "Lync Server 2013 Best Practices Analyzer",
          typeId: "6e3d1e71-42a3-1887-ec9a-1c4e59f101b4",
          type: "productname"
        },
        {
          title: "Lync Server 2013 Debugging Tools",
          typeId: "f6eb9b2e-3e0c-50d5-f9dd-54760a9ba8d7",
          type: "productname"
        },
        {
          title: "Lync Server 2013 Monitoring Management Pack",
          typeId: "a15fc2bd-0f01-8e92-6e41-196554995002",
          type: "productname"
        },
        {
          title: "Lync Server 2013 Stress and Performance Tool",
          typeId: "12f6a725-bbc2-41af-e876-f8d634b12898",
          type: "productname"
        },
        {
          title: "Lync Server 2013 Watcher Node",
          typeId: "03529c40-7619-218a-5780-8938069a45ea",
          type: "productname"
        },
        {
          title: "SQL Server Migration Assistant",
          typeId: "ef3236fb-4afc-3a6b-7f0a-89bacdc102d4",
          type: "productname"
        },
        {
          title: "Server management tools",
          typeId: "fc4768af-b479-48fe-bdd4-f37b18c9fa82",
          type: "productname"
        },
        {
          title: "Service Bus for Windows Server",
          typeId: "ee6083b2-ac6f-dbf2-c10e-c43d3a34f55c",
          type: "productname"
        },
        {
          title: "Service Fabric stand-alone package for Windows Server",
          typeId: "203b5928-37f5-6e14-eb0d-0eac8f141aaf",
          type: "productname"
        },
        {
          title: "Software Inventory Logging Aggregator 1.0 for Windows Server",
          typeId: "be8a3671-da88-fd15-e16b-848a8d87bb33",
          type: "productname"
        },
        {
          title: "System Center Advisor",
          typeId: "a93a4e0a-2391-cf47-a100-233c756ef3b5",
          type: "productname"
        },
        {
          title: "System Center App Controller",
          typeId: "b66b861c-5e1d-74f4-6526-fb2a524c2b51",
          type: "productname"
        },
        {
          title: "System Center Capacity Planner",
          typeId: "a0c11a51-fcf5-f0fc-47ef-20e1d1166065",
          type: "productname"
        },
        {
          title: "System Center Configuration Manager",
          typeId: "659281ab-2209-ee61-a4e7-37d9380e227e",
          type: "productname"
        },
        {
          title: "System Center Data Protection Manager",
          typeId: "d3da7e32-341a-a807-630b-c7b3a1baae96",
          type: "productname"
        },
        {
          title: "System Center Desktop Error Monitoring",
          typeId: "89f704de-9654-bade-67a4-e939493e1e1f",
          type: "productname"
        },
        {
          title: "System Center Endpoint Protection",
          typeId: "f710bc13-036a-6279-90ac-6c27e8b4726e",
          type: "productname"
        },
        {
          title: "System Center Essentials",
          typeId: "04e6be9c-181b-5afb-7c6d-f57b80d73454",
          type: "productname"
        },
        {
          title: "System Center Mobile Device Manager",
          typeId: "26902d7c-349a-5971-ff22-8fbe5b541e32",
          type: "productname"
        },
        {
          title: "System Center Operations Manager",
          typeId: "00ad407a-b817-9ed3-9103-dd4815af0d3c",
          type: "productname"
        },
        {
          title: "System Center Orchestrator",
          typeId: "8493588c-00c3-eba7-49dc-71f97fabb675",
          type: "productname"
        },
        {
          title: "System Center Service Manager",
          typeId: "df29d92b-4992-0048-5ad4-6ff5d34af7b5",
          type: "productname"
        },
        {
          title: "System Center Virtual Machine Manager",
          typeId: "5861b0c8-5fec-5a33-cacd-7d0cd4f2c8e7",
          type: "productname"
        },
        {
          title: "Unified Communications Managed API v3.0 Software Development Kit",
          typeId: "ff725119-eefd-c741-b0c3-eb3ab6aa4f03",
          type: "productname"
        },
        {
          title: "Workflow Manager 1.0",
          typeId: "66eeeda5-303e-417f-79ed-71d7ceeafcfc",
          type: "productname"
        },
        {
          title: "Workflow Manager Client 1.0",
          typeId: "249b3fe5-509e-fce3-4e75-2e04f80735fc",
          type: "productname"
        },
        {
          title: "iSCSI Software Target 3.3",
          typeId: "6b02c1e3-9549-d602-e851-caef4a4be2b2",
          type: "productname"
        }
      ]
    },
    {
      title: "Servers",
      childNodes: [
        {
          title: "BizTalk Server",
          typeId: "f2709ed7-7e1a-033d-6569-c4d0ea73d87e",
          type: "productname"
        },
        {
          title: "Commerce Server 2009",
          typeId: "5081570a-e2e8-eaf6-ecea-316fff84fc07",
          type: "productname"
        },
        {
          title: "DATAllegro Archive",
          typeId: "8d616d86-c706-e4c2-eb08-edadb40516ee",
          type: "productname"
        },
        {
          title: "Dell Quickstart Data Warehouse Appliance",
          typeId: "a9dd3a3d-41be-cf36-e9cc-78380d7e87aa",
          type: "productname"
        },
        {
          title: "Duet for Office and SAP 1.5",
          typeId: "c7779ba5-e0f1-8c7d-88ff-ef83869afd36",
          type: "productname"
        },
        {
          title: "Exchange Server",
          typeId: "d8c99dd8-9c55-07d6-f4e1-24a3eb4b6350",
          type: "productname"
        },
        {
          title: "FAST AdMomentum 3",
          typeId: "c518fe59-f072-de4e-c750-a1175cc148ae",
          type: "productname"
        },
        {
          title: "FAST Application Management Services",
          typeId: "ed5f0218-ef89-f9a4-5b90-48d9a2adb612",
          type: "productname"
        },
        {
          title: "FAST ESP",
          typeId: "57988591-67c0-5f04-0872-b46c0866ee9a",
          type: "productname"
        },
        {
          title: "FAST Featured Content 1.3",
          typeId: "c90ca293-d682-f0f4-7740-74e5eb88d6a4",
          type: "productname"
        },
        {
          title: "FAST ImPulse",
          typeId: "e14bb2df-caf7-56fc-e547-cac9f89ba587",
          type: "productname"
        },
        {
          title: "FAST Recommendations",
          typeId: "1f01c13d-7d4d-5724-5d0a-e9a47827bc23",
          type: "productname"
        },
        {
          title: "FAST Search Server 2010 for Internal Applications",
          typeId: "bd3bbde7-388f-a4d0-1084-6061d6eb61b7",
          type: "productname"
        },
        {
          title: "FAST Unity 2.5",
          typeId: "5e27a3c4-da5a-1d9f-15f8-09cb4b343aa1",
          type: "productname"
        },
        {
          title: "Forefront Identity Manager 2010",
          typeId: "ff3dad31-ddb8-03e7-af6f-12829471af69",
          type: "productname"
        },
        {
          title: "Groove Server 2010",
          typeId: "57e1b8e4-29b8-cc35-8b7d-ba6b60989d2d",
          type: "productname"
        },
        {
          title: "HDInsight Server",
          typeId: "8e5add19-1596-0e90-9e0a-7ea1de0a6350",
          type: "productname"
        },
        {
          title: "HP Database Consolidation Solution for SQL Server",
          typeId: "ca30d990-eef0-3bdf-7be0-b044117b4ce2",
          type: "productname"
        },
        {
          title: "HP Enterprise Data Warehouse For",
          typeId: "6097d8ef-ad2a-3e09-3156-94d258d4707c",
          type: "productname"
        },
        {
          title: "Host Integration Server",
          typeId: "cd34b51a-5161-d2ec-bf9e-d1a4aee70d4d",
          type: "productname"
        },
        {
          title: "Hyper-V Server",
          typeId: "9e9f90be-24ad-3d88-1f56-adb2c2c0063c",
          type: "productname"
        },
        {
          title: "Hyper-V Server 2008",
          typeId: "e5e164de-0701-6fcd-86bf-c2383848cc5b",
          type: "productname"
        },
        {
          title: "Internet Information Services",
          typeId: "8f070677-2cda-b55d-be7d-1484d98afc41",
          type: "productname"
        },
        {
          title: "Lync 2010 Attendant",
          typeId: "f9188d3a-3e53-7761-1d5e-b39a73ca172d",
          type: "productname"
        },
        {
          title: "Lync 2010 Attendee",
          typeId: "db9ebfc9-8fbe-bd0d-a4d3-b1d51f461544",
          type: "productname"
        },
        {
          title: "Lync 2010 Group Chat",
          typeId: "60ee7234-2576-b5d6-4ba1-1d5cbba4729b",
          type: "productname"
        },
        {
          title: "Lync 2010 Software Development Kit",
          typeId: "e16aae3b-0dcd-ed62-fef4-664f642b54e7",
          type: "productname"
        },
        {
          title: "Lync Phone Edition",
          typeId: "930930e4-7a70-f973-f0a5-df6188c96d89",
          type: "productname"
        },
        {
          title: "Lync Server",
          typeId: "2f780816-8e9e-b97b-5e43-a6b802a6d96e",
          type: "productname"
        },
        {
          title: "Mohoro",
          typeId: "b14d40d7-df2e-5544-0b48-effd4951a51f",
          type: "productname"
        },
        {
          title: "Office Communications Server 2007",
          typeId: "24a591da-a0e5-f5bb-d327-befe150e9753",
          type: "productname"
        },
        {
          title: "Office Communicator Mobile (2007 Release)",
          typeId: "985b6e6a-18fb-7c16-8437-e93afc0a6deb",
          type: "productname"
        },
        {
          title: "Office Forms Server 2007",
          typeId: "63a7698b-9c6f-63b9-de71-c9f94adf7444",
          type: "productname"
        },
        {
          title: "Office Groove Server 2007",
          typeId: "9fccbc6c-6b52-2296-8197-5969a5daa675",
          type: "productname"
        },
        {
          title: "Office Online Server",
          typeId: "1dadf355-d94d-a4d8-bcb7-759fbe465d59",
          type: "productname"
        },
        {
          title: "Office PerformancePoint Server 2007",
          typeId: "2717a068-7505-1035-3e7d-17c4938746d2",
          type: "productname"
        },
        {
          title: "Office Web Apps Server 2013",
          typeId: "2ccd9904-0b2b-639d-6c70-c08021584372",
          type: "productname"
        },
        {
          title: "Opalis Integration Server",
          typeId: "56ec7e3c-5d83-a65c-5467-6d6709e1733a",
          type: "productname"
        },
        {
          title: "ProClarity Analytics Server 6.3",
          typeId: "5d637958-b208-c43b-9232-6af326abd084",
          type: "productname"
        },
        {
          title: "ProClarity Dashboard Server 6.3",
          typeId: "a27e7ef7-b485-a2c0-e1f2-8dbf046a1ade",
          type: "productname"
        },
        {
          title: "ProClarity Desktop Professional 6.3",
          typeId: "3726a662-6dc9-329b-8ef9-0487fb67aa45",
          type: "productname"
        },
        {
          title: "Project Portfolio Server 2007",
          typeId: "a7be660c-6520-362a-e9f6-a2c0cd93278a",
          type: "productname"
        },
        {
          title: "Project Server",
          typeId: "13a46343-c7e9-33a8-850c-ba5ec41b931f",
          type: "productname"
        },
        {
          title: "SQL Server 2008",
          typeId: "6c1a55e1-8e9e-c24f-76ab-040ee7de5d66",
          type: "productname"
        },
        {
          title: "SQL Server 2008 R2",
          typeId: "f72e136e-3778-27f4-3c41-d5d7c95f007d",
          type: "productname"
        },
        {
          title: "SQL Server 2008 R2 PowerPivot for Excel 2010",
          typeId: "358b6351-b236-9db7-f022-6cf079ef47e7",
          type: "productname"
        },
        {
          title: "SQL Server 2012",
          typeId: "d989f327-bbc7-94ec-7342-073be5beae1c",
          type: "productname"
        },
        {
          title: "SQL Server 2012 Enterprise Core",
          typeId: "97f6ed6a-29fe-ea48-1cc9-e6224984177a",
          type: "productname"
        },
        {
          title: "SQL Server 2012 Parallel Data Warehouse (APS)",
          typeId: "f1376bba-0775-de89-9c7f-16a79e90a259",
          type: "productname"
        },
        {
          title: "SQL Server 2014",
          typeId: "a6856995-69ab-9519-68db-64d99ff18e81",
          type: "productname"
        },
        {
          title: "SQL Server 2016",
          typeId: "5ed13740-e23b-ce30-13b9-e01c9bc9c6ac",
          type: "productname"
        },
        {
          title: "SQL Server Compact",
          typeId: "1b9ed25e-a036-d5ce-2166-7e1c41314aa1",
          type: "productname"
        },
        {
          title: "SQL Server Early Adopter Program",
          typeId: "5fa09b52-2658-8b89-2c07-1cf2145a1617",
          type: "productname"
        },
        {
          title: "SQL Server Management Studio",
          typeId: "c5ae9bf2-ff33-4a55-c96d-8310dc1e5a41",
          type: "productname"
        },
        {
          title: "Search Server",
          typeId: "f2bc9de0-8a11-2de2-3afe-33d90f8dd6d9",
          type: "productname"
        },
        {
          title: "SharePoint Foundation",
          typeId: "7ffce26d-6e0e-3c5b-bc56-540af77afa82",
          type: "productname"
        },
        {
          title: "SharePoint Server",
          typeId: "db4415b9-8969-e4b4-8f8d-208d9e8b32b4",
          type: "productname"
        },
        {
          title: "Windows Essential Business Server 2008",
          typeId: "b2978791-5b52-93d2-a531-4f77621293b2",
          type: "productname"
        },
        {
          title: "Windows HPC Server 2008",
          typeId: "3eb2dfec-172b-dc9c-fb92-45d8e1a1e6c6",
          type: "productname"
        },
        {
          title: "Windows Live OneCare for Server",
          typeId: "3f416d29-2ee5-30a6-ce67-79e4926c1f9c",
          type: "productname"
        },
        {
          title: "Windows MultiPoint Server",
          typeId: "3c8fda24-88ce-a093-7f44-5dddc6ca3f9f",
          type: "productname"
        },
        {
          title: "Windows Remote Management",
          typeId: "b3c7ce22-4f33-eb1d-5ba4-94c27124eb33",
          type: "productname"
        },
        {
          title: "Windows SMTP Server",
          typeId: "62b4eef0-0058-a959-6166-bc0cba0ce1f5",
          type: "productname"
        },
        {
          title: "Windows Server 2008",
          typeId: "8ac46096-8f3d-8e41-fc6d-4748c72816ba",
          type: "productname"
        },
        {
          title: "Windows Server 2008 for Windows",
          typeId: "94d2e7e3-606d-563e-b410-64363a727f3f",
          type: "productname"
        },
        {
          title: "Windows Server 2012",
          typeId: "c460a589-2b54-c4f3-1c1c-e94bfe0a0369",
          type: "productname"
        },
        {
          title: "Windows Server 2012 R2",
          typeId: "3b846d4c-8601-be61-7230-bade94c12cf4",
          type: "productname"
        },
        {
          title: "Windows Server 2016",
          typeId: "46a5a87d-954c-82ac-3ca1-97a3b8a6983e",
          type: "productname"
        },
        {
          title: "Windows Server AppFabric",
          typeId: "cfe5181d-603a-b7b2-1939-12d5638533df",
          type: "productname"
        },
        {
          title: "Windows Server Developer Preview",
          typeId: "f32c0424-7491-b548-5137-6f222e5df12f",
          type: "productname"
        },
        {
          title: "Windows Server Technical Preview",
          typeId: "f0ff9ff7-de91-16b8-7929-df8c2f0e8a38",
          type: "productname"
        },
        {
          title: "Windows Server Update Services",
          typeId: "8968914d-8760-3341-7e6c-abc900a7c9fe",
          type: "productname"
        },
        {
          title: "Windows SharePoint Services 3.0",
          typeId: "bae1f9d2-4979-7486-2783-686b802f86df",
          type: "productname"
        },
        {
          title: "Windows Small Business Server",
          typeId: "5f5d8b88-4f3a-5242-7bfa-1034cbbb0ecc",
          type: "productname"
        },
        {
          title: "Windows Storage Server 2008",
          typeId: "9769de61-7a9d-5e2c-2c2d-344b012225af",
          type: "productname"
        },
        {
          title: "Windows Storage Server 2012",
          typeId: "a433fa2b-34cb-ed3a-eefe-4545b34c9c4e",
          type: "productname"
        },
        {
          title: "Windows Workflow Foundation",
          typeId: "d0b1ab94-fc5c-a42e-a455-02c1defd64e9",
          type: "productname"
        }
      ]
    },
    {
      title: "Skype",
      childNodes: [
        {
          title: "Skype",
          typeId: "5814cb9c-9e23-6e80-0977-57dc60a556ee",
          type: "productname"
        }
      ]
    },
    {
      title: "Surface",
      childNodes: [
        {
          title: "Surface 2",
          typeId: "f1f0c2ad-e19e-bae1-bf1b-183dede46eed",
          type: "productname"
        },
        {
          title: "Surface 3",
          typeId: "d515c767-dbe8-c204-48ff-db248b1de867",
          type: "productname"
        },
        {
          title: "Surface 65W Power Supply",
          typeId: "15c090d3-8996-e063-bac2-b64b216f0d53",
          type: "productname"
        },
        {
          title: "Surface Book",
          typeId: "d041cadf-38c0-7c1b-f5cd-1ac8258ab9ef",
          type: "productname"
        },
        {
          title: "Surface Dock",
          typeId: "5eaf07f5-586c-040d-fb6e-58f914966515",
          type: "productname"
        },
        {
          title: "Surface Hub",
          typeId: "6875d467-e2ee-1a27-804e-b9b6132d57b5",
          type: "productname"
        },
        {
          title: "Surface Pro",
          typeId: "82bf3e10-997f-55ce-c854-51b8b5431a3c",
          type: "productname"
        },
        {
          title: "Surface RT",
          typeId: "391b1338-06fd-3525-0271-3da098f0895a",
          type: "productname"
        },
        {
          title: "Surface Studio",
          typeId: "a2919837-9c91-ab9a-b5dc-53b71b837bf8",
          type: "productname"
        }
      ]
    },
    {
      title: "Windows",
      childNodes: [
        {
          title: "Windows 10",
          typeId: "b6e45166-be4c-b92c-d576-7290bf44ac5b",
          type: "productname"
        },
        {
          title: "Windows 10 Mobile",
          typeId: "157ed35f-3656-c4b9-bade-9ccc5955ccac",
          type: "productname"
        },
        {
          title: "Windows 7",
          typeId: "4220f4ac-4103-8590-2303-e0e75fb7bd9f",
          type: "productname"
        },
        {
          title: "Windows 8",
          typeId: "7f8131c5-c123-914a-c640-6cb9eb7953f0",
          type: "productname"
        },
        {
          title: "Windows 8.1",
          typeId: "edfeb133-9569-dff2-54d7-26f82128bbca",
          type: "productname"
        },
        {
          title: "Windows Developer Preview",
          typeId: "1b0dac99-dc0e-4ab2-5da0-8a3b61c7a960",
          type: "productname"
        },
        {
          title: "Windows Embedded",
          typeId: "e5e4ff36-6ad0-f40d-ff76-a057fb6f188d",
          type: "productname"
        },
        {
          title: "Windows Embedded CE 6.0",
          typeId: "42ff3826-199d-eacc-0817-28139511a199",
          type: "productname"
        },
        {
          title: "Windows Embedded Industry",
          typeId: "e699f476-e3d8-8a53-4cf9-4a22c2a1c8ba",
          type: "productname"
        },
        {
          title: "Windows Embedded POSReady",
          typeId: "cd556436-60bc-f38a-66eb-4e868dc6f45f",
          type: "productname"
        },
        {
          title: "Windows Media Center",
          typeId: "fccc81d1-06f1-35f2-c8ef-d6b27ebc77cb",
          type: "productname"
        },
        {
          title: "Windows Phone 8 for Business",
          typeId: "0a122786-b3cf-a690-466d-8ed3f47fb98d",
          type: "productname"
        },
        {
          title: "Windows Phone 8.1",
          typeId: "8f29c211-25d7-e44e-5d32-753acdc1f76b",
          type: "productname"
        },
        {
          title: "Windows RT",
          typeId: "3dc1ffb1-92de-b3b8-fb67-0ab492a650d0",
          type: "productname"
        },
        {
          title: "Windows XP",
          typeId: "8898390f-8fac-c6c6-cc62-a2270b42d0b3",
          type: "productname"
        }
      ]
    },
    {
      title: "Windows Add-On Programs",
      childNodes: [
        {
          title: "Advanced Group Policy Management",
          typeId: "787de70b-4ce5-93cd-78a6-980581111b26",
          type: "productname"
        },
        {
          title: "Application Virtualization",
          typeId: "19f9f908-7b1d-f202-ddd9-19d2fc5839a5",
          type: "productname"
        },
        {
          title: "Baseline Security Analyzer",
          typeId: "6fa443d3-7255-4061-4683-abb1838b8322",
          type: "productname"
        },
        {
          title: "BitLocker Administration and Monitoring",
          typeId: "ec4ac513-82fc-99bc-4f29-3ea0977463f7",
          type: "productname"
        },
        {
          title: "Desktop Optimization Pack",
          typeId: "60005648-1762-67e5-4b42-cdb076076de7",
          type: "productname"
        },
        {
          title: "Diagnostics and Recovery Toolset",
          typeId: "08cbc580-f6df-2bd1-4dec-3e977e7e7164",
          type: "productname"
        },
        {
          title: "Enterprise Desktop Virtualization",
          typeId: "76d30ef7-181a-feaf-fe28-7712ff3372b7",
          type: "productname"
        },
        {
          title: "Genuine Windows",
          typeId: "f8256a0c-fc0f-8aca-963f-6b2112360309",
          type: "productname"
        },
        {
          title: "Microsoft Update",
          typeId: "1a2cb90f-6361-6efe-66f5-83f1f6d39a11",
          type: "productname"
        },
        {
          title: "Mobile Ads",
          typeId: "340e420d-912d-f3b0-3f9f-b511f916f7ab",
          type: "productname"
        },
        {
          title: "Outlook Social Connector Beta",
          typeId: "5cbe88d9-b911-69ea-869f-2821f4abad36",
          type: "productname"
        },
        {
          title: "Ultra Low Cost PC OEM Preinstall Kit",
          typeId: "e3c2d3c3-b1d7-565d-0325-23b6320e4f38",
          type: "productname"
        },
        {
          title: "Virtual PC 2007",
          typeId: "ea0844ae-0865-dd22-c0f0-5eedaa5fc2d6",
          type: "productname"
        },
        {
          title: "Windows Automated Installation Kit for Windows 7",
          typeId: "86205e97-93c3-6ce3-5e85-0b7c38abc146",
          type: "productname"
        },
        {
          title: "Windows Azure Pack (on Windows",
          typeId: "919d3a8a-907b-b729-4001-7d462893cb2c",
          type: "productname"
        },
        {
          title: "Windows Embedded Device Manager",
          typeId: "dee5837e-7963-039d-0aa2-6188b4ce255e",
          type: "productname"
        },
        {
          title: "Windows Essentials OEM Preinstall Kit",
          typeId: "a7763f3b-bf5e-6cb0-7ed4-227ea0d92e81",
          type: "productname"
        },
        {
          title: "Windows Installer 4.5",
          typeId: "1ae5bd4a-c5ce-3f12-53ae-ccd14aff6488",
          type: "productname"
        },
        {
          title: "Windows Live Mobile Browse",
          typeId: "29b015de-2f21-5c4f-7c48-2009a2e82a0c",
          type: "productname"
        },
        {
          title: "Windows Live OneCare",
          typeId: "7dc67d4f-fe11-3c00-b850-3f656c4ab106",
          type: "productname"
        },
        {
          title: "Windows Preinstallation Environment",
          typeId: "a2b47265-f49f-bc66-03f5-c7d9b0059a3d",
          type: "productname"
        },
        {
          title: "Windows Telemetry Specifications",
          typeId: "91154ac4-5403-9ef5-bcde-05447704d8d9",
          type: "productname"
        },
        {
          title: "Windows Thin PC",
          typeId: "a19e9908-40a7-33f5-5e68-c739669b771a",
          type: "productname"
        },
        {
          title: "Windows Update",
          typeId: "1a2c19e1-ea6d-aceb-716b-4425268bbb40",
          type: "productname"
        },
        {
          title: "Windows Virtual PC",
          typeId: "5090abb3-a341-399b-255b-7770335eda25",
          type: "productname"
        }
      ]
    },
    {
      title: "Xbox and PC Games",
      childNodes: [
        {
          title: "Games for Windows - LIVE",
          typeId: "7e87a63a-5ac8-76a5-811f-481b7678d4c4",
          type: "productname"
        },
        {
          title: "Kinect for Xbox 360",
          typeId: "9c97ec34-a592-ad31-4310-d2d806cbd670",
          type: "productname"
        },
        {
          title: "Xbox",
          typeId: "e2c47957-4e59-4b74-a537-5db6406c73ad",
          type: "productname"
        },
        {
          title: "Xbox Live",
          typeId: "ad8b78c0-0af7-aa8b-eebc-575155398a64",
          type: "productname"
        }
      ]
    },
    {
      title: "Zune",
      childNodes: [
        {
          title: "Zune 120GB Digital Media Player",
          typeId: "11be0ae4-e2aa-4a85-4ddd-a4f3794fe774",
          type: "productname"
        },
        {
          title: "Zune 30GB Digital Media Player",
          typeId: "7681c84d-b628-f724-3de3-fe61ce2933dd",
          type: "productname"
        },
        {
          title: "Zune 4GB Digital Media Player",
          typeId: "b208ab08-8036-c6f0-6442-5a1df4566d58",
          type: "productname"
        },
        {
          title: "Zune 80GB Digital Media Player",
          typeId: "c4c4da1a-0939-f287-c7ce-0ee2642f0e53",
          type: "productname"
        },
        {
          title: "Zune 8GB Digital Media Player",
          typeId: "a023d65d-fcca-368e-b57f-df301e7ed48b",
          type: "productname"
        },
        {
          title: "Zune Audio Cable",
          typeId: "ee747fc5-7077-79f3-69d2-8de9502265eb",
          type: "productname"
        },
        {
          title: "Zune Cable Pack",
          typeId: "4ed6dfae-7b75-a536-f240-9f666a1a727a",
          type: "productname"
        },
        {
          title: "Zune Car",
          typeId: "7b5786df-fed6-2a7d-f25e-fae8b7f5f1f2",
          type: "productname"
        },
        {
          title: "Zune Dock",
          typeId: "ff42f924-5602-49e2-4040-c9cc23c86cb0",
          type: "productname"
        },
        {
          title: "Zune Dual Connect Remote",
          typeId: "5f204931-9a5a-c3aa-6241-b6f5077d6f11",
          type: "productname"
        },
        {
          title: "Zune FM Transmitter",
          typeId: "9e19b743-2d50-bb2f-e258-17099e42791c",
          type: "productname"
        },
        {
          title: "Zune HD 16GB",
          typeId: "ac63371e-cb84-1eab-9dac-dd364f32aabd",
          type: "productname"
        },
        {
          title: "Zune HD 64GB",
          typeId: "c451e3ae-040b-5514-c49a-df1d9aad9025",
          type: "productname"
        },
        {
          title: "Zune Leather Case",
          typeId: "09d40748-f79b-b3ec-ede4-28ae8099e62b",
          type: "productname"
        },
        {
          title: "Zune Live",
          typeId: "e2456bd2-3f6c-7dc9-8d84-127807482a59",
          type: "productname"
        },
        {
          title: "Zune Premium Earphones",
          typeId: "b6a5bcf9-4e0c-3804-39c2-f1dc16ca5fee",
          type: "productname"
        },
        {
          title: "Zune Standard Earbuds",
          typeId: "a66813ad-8e86-dd46-805c-0a12d7d965e7",
          type: "productname"
        },
        {
          title: "Zune Sync Cable",
          typeId: "86ddd527-1f3f-6953-167f-855a9e927e26",
          type: "productname"
        },
        {
          title: "Zune Travel Pack",
          typeId: "2f1f5f04-9a4b-2a52-423f-eb4284b9f34a",
          type: "productname"
        },
        {
          title: "Zune software",
          typeId: "1452f971-2e53-8623-7ecf-700f6a452615",
          type: "productname"
        }
      ]
    }
  ];
}
